(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["algolia-header-search"] && !Shopify.designMode) return;
  try {
    
// ⚠ Auto-generated from src/sections/algolia-header-search/algolia-header-search.ts — do not edit directly.
// src/sections/algolia-header-search/algolia-header-search.ts
"use strict";
(() => {
  // src/sections/algolia-main-search/constants.ts
  var CDN_ALGOLIASEARCH = "https://cdn.jsdelivr.net/npm/algoliasearch@5.56.0/dist/lite/builds/browser.umd.js";
  var SRI_ALGOLIASEARCH = "sha384-jydndPKly6IFOH8FPmOV3qHV/YxfBbkZBbaNHhojUEnFzJpw458cQC2x80yc6cdb";
  var CDN_SEARCH_INSIGHTS = "https://cdn.jsdelivr.net/npm/search-insights@2.17.3/dist/search-insights.min.js";
  var SRI_SEARCH_INSIGHTS = "sha384-puGTibgj5tll4rKBSZMNWXFBG+MuObLcSQE3VnZ/PbPozbHGK7qhg0CFKG9FBUjZ";
  var SEARCH_DEBOUNCE_MS = 200;
  var MIN_QUERY_LEN = 3;
  var ALGOLIA_PRODUCT_ATTRIBUTES_TO_RETRIEVE = [
    "objectID",
    "id",
    "handle",
    "url",
    "title",
    "image",
    "price",
    "available",
    "inventory_available",
    "inventory_quantity",
    "variant_id",
    "template_suffix",
    "tags",
    "contenance",
    "subtitle",
    "related_products",
    "meta.custom.subtitle",
    "meta.custom.label",
    "meta.custom.contenance",
    "meta.custom.capacity",
    "meta.custom.format",
    "meta.custom.media_tags",
    "meta.custom.product_tags",
    "meta.custom.related_products",
    "meta.custom.gift_product",
    "meta.bundle"
  ];
  var ICON_BULLET = `<svg xmlns='http://www.w3.org/2000/svg' width='17' height='16' viewBox='0 0 17 16' fill='none'><path d='M9.5 8C9.5 8.55228 9.05228 9 8.5 9C7.94772 9 7.5 8.55228 7.5 8C7.5 7.44772 7.94772 7 8.5 7C9.05228 7 9.5 7.44772 9.5 8Z' fill='currentColor'/></svg>`;

  // src/sections/algolia-main-search/load-script.ts
  var pending = /* @__PURE__ */ new Map();
  function loadScript(src, integrity) {
    const cached = pending.get(src);
    if (cached) return cached;
    const promise = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = src;
      script.crossOrigin = "anonymous";
      if (integrity) script.integrity = integrity;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
      document.head.appendChild(script);
    });
    pending.set(src, promise);
    return promise;
  }

  // src/sections/algolia-main-search/insights.ts
  var ALGOLIA_USER_TOKEN_KEY = "diptyque:algolia:user-token";
  var PIXEL_CONFIG_KEY = "algolia_config";
  var PIXEL_CLICKED_OBJECTS_KEY = "algolia_analytics_clicked_objects";
  var MAX_PIXEL_CLICKED_OBJECTS = 40;
  var ONE_TRUST_ANALYTICS_PATTERN = /perform|analyt|statis|mesure|audience/i;
  var ONE_TRUST_ANALYTICS_GROUP_IDS = ["PERF", "C0002"];
  var CONSENT_POLL_INTERVAL_MS = 250;
  var CONSENT_POLL_ATTEMPTS = 60;
  var initPromise = null;
  var initKey = "";
  var trackingAllowed = false;
  var cachedUserToken = null;
  var customerPrivacyPromise = null;
  function loadCustomerPrivacy() {
    if (customerPrivacyPromise) return customerPrivacyPromise;
    customerPrivacyPromise = new Promise((resolve) => {
      const shopify = window.Shopify;
      if (shopify?.customerPrivacy) {
        resolve();
        return;
      }
      if (typeof shopify?.loadFeatures !== "function") {
        resolve();
        return;
      }
      const done = () => resolve();
      window.setTimeout(done, 3e3);
      try {
        shopify.loadFeatures(
          [{ name: "consent-tracking-api", version: "0.1" }],
          done
        );
      } catch {
        done();
      }
    });
    return customerPrivacyPromise;
  }
  function shopifyAnalyticsAllowed() {
    const customerPrivacy = window.Shopify?.customerPrivacy;
    if (typeof customerPrivacy?.analyticsProcessingAllowed !== "function") {
      return null;
    }
    try {
      return customerPrivacy.analyticsProcessingAllowed() === true;
    } catch {
      return null;
    }
  }
  function oneTrustConsentFromCookie() {
    const match = document.cookie.match(/(?:^|;\s*)OptanonConsent=([^;]*)/);
    if (!match) return null;
    const groups = new URLSearchParams(match[1]).get("groups");
    if (!groups) return null;
    const granted = groups.split(",").map((pair) => pair.split(":")).filter(([, value]) => value?.trim() === "1").map(([id]) => id?.trim());
    return granted.some((id) => id && ONE_TRUST_ANALYTICS_GROUP_IDS.includes(id));
  }
  function oneTrustAnalyticsAllowedFromSdk() {
    const consentWindow = window;
    const active = consentWindow.OnetrustActiveGroups;
    if (typeof active !== "string" || !active) return null;
    const activeIds = active.split(",").map((id) => id.trim()).filter(Boolean);
    let groups = [];
    try {
      groups = consentWindow.OneTrust?.GetDomainData?.().Groups ?? [];
    } catch {
      groups = [];
    }
    const analyticsIds = groups.filter(
      (group) => ONE_TRUST_ANALYTICS_PATTERN.test(
        `${group.GroupName ?? ""} ${group.Type ?? ""}`
      )
    ).map((group) => group.CustomGroupId).filter((id) => Boolean(id));
    const ids = analyticsIds.length ? analyticsIds : ONE_TRUST_ANALYTICS_GROUP_IDS;
    return ids.some((id) => activeIds.includes(id)) ? true : null;
  }
  function oneTrustAnalyticsAllowed() {
    const cookie = oneTrustConsentFromCookie();
    const live = oneTrustAnalyticsAllowedFromSdk();
    if (cookie === true || live === true) return true;
    if (cookie === false || live === false) return false;
    return null;
  }
  async function resolveTrackingConsent() {
    await loadCustomerPrivacy();
    return shopifyAnalyticsAllowed() === true || oneTrustAnalyticsAllowed() === true;
  }
  var trackingEnabledCallbacks = [];
  function flushTrackingEnabledCallbacks() {
    const callbacks = trackingEnabledCallbacks.splice(0);
    callbacks.forEach((callback) => callback());
  }
  var consentWatcherStarted = false;
  function watchConsentChanges(appId, apiKey, indexName) {
    if (consentWatcherStarted) return;
    consentWatcherStarted = true;
    const reinit = () => {
      if (trackingAllowed) return;
      initPromise = null;
      initKey = "";
      void initAlgoliaInsights(appId, apiKey, indexName);
    };
    document.addEventListener("visitorConsentCollected", reinit);
    window.addEventListener("OneTrustGroupsUpdated", reinit);
    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (trackingAllowed || attempts > CONSENT_POLL_ATTEMPTS) {
        window.clearInterval(timer);
        return;
      }
      if (oneTrustAnalyticsAllowed() === true || shopifyAnalyticsAllowed() === true) {
        window.clearInterval(timer);
        reinit();
      }
    }, CONSENT_POLL_INTERVAL_MS);
  }
  function createToken() {
    if ("crypto" in window && "randomUUID" in window.crypto) {
      return window.crypto.randomUUID();
    }
    return `anonymous-${Date.now()}-${Math.random().toString(36).slice(2)}`;
  }
  function getAlgoliaUserToken() {
    if (!trackingAllowed) {
      cachedUserToken ?? (cachedUserToken = createToken());
      return cachedUserToken;
    }
    try {
      const storedToken = window.localStorage.getItem(ALGOLIA_USER_TOKEN_KEY);
      if (storedToken) {
        cachedUserToken = storedToken;
        return storedToken;
      }
      const nextToken = cachedUserToken ?? createToken();
      window.localStorage.setItem(ALGOLIA_USER_TOKEN_KEY, nextToken);
      cachedUserToken = nextToken;
      return nextToken;
    } catch {
      cachedUserToken ?? (cachedUserToken = createToken());
      return cachedUserToken;
    }
  }
  function installInsightsQueue() {
    const insightsWindow = window;
    if (typeof insightsWindow.aa === "function") return insightsWindow.aa;
    const queued = [];
    const aa = ((...args) => {
      queued.push(args);
    });
    aa.queue = queued;
    insightsWindow.AlgoliaAnalyticsObject = "aa";
    insightsWindow.aa = aa;
    return aa;
  }
  async function initAlgoliaInsights(appId, apiKey, indexName) {
    const key = `${appId}:${apiKey}`;
    if (initPromise && initKey === key) return initPromise;
    initKey = key;
    initPromise = (async () => {
      trackingAllowed = await resolveTrackingConsent();
      if (!trackingAllowed) {
        watchConsentChanges(appId, apiKey, indexName);
        return null;
      }
      const aa = installInsightsQueue();
      const userToken = getAlgoliaUserToken();
      aa("init", { appId, apiKey, userToken, useCookie: false });
      writePixelConfig({ appId, apiKey, indexName, userToken });
      try {
        await loadScript(CDN_SEARCH_INSIGHTS, SRI_SEARCH_INSIGHTS);
      } catch (error) {
        console.warn("Algolia Insights could not be loaded", error);
        return null;
      }
      flushTrackingEnabledCallbacks();
      return aa;
    })();
    return initPromise;
  }
  function sendAlgoliaEvent(method, payload) {
    if (!trackingAllowed) return false;
    const aa = window.aa;
    if (!aa || !payload.index || payload.objectIDs.length === 0) return false;
    aa(method, payload);
    return true;
  }
  function writePixelConfig({
    appId,
    apiKey,
    indexName,
    userToken
  }) {
    if (!trackingAllowed || !indexName) return;
    try {
      window.localStorage.setItem(
        PIXEL_CONFIG_KEY,
        JSON.stringify({
          app_id: appId,
          search_api_key: apiKey,
          index_name: indexName,
          user_token: userToken
        })
      );
    } catch {
      return;
    }
  }
  function recordClickForPixel(analytics) {
    if (!trackingAllowed || !analytics.queryID) return;
    try {
      const stored = window.localStorage.getItem(PIXEL_CLICKED_OBJECTS_KEY);
      const previous = stored ? JSON.parse(stored) : [];
      const others = previous.filter(
        (record) => !record.objectIDs?.includes(
          analytics.objectID
        )
      );
      others.push({
        index: analytics.index,
        objectIDs: [analytics.objectID],
        queryID: analytics.queryID,
        ...analytics.position ? { positions: [analytics.position] } : {},
        ...analytics.productID ? { productId: analytics.productID } : {}
      });
      window.localStorage.setItem(
        PIXEL_CLICKED_OBJECTS_KEY,
        JSON.stringify(others.slice(-MAX_PIXEL_CLICKED_OBJECTS))
      );
    } catch {
      return;
    }
  }
  function readProductAnalytics(element) {
    const productEl = element.closest("[data-algolia-product]");
    if (!productEl) return null;
    const index = productEl.dataset.algoliaIndex;
    const objectID = productEl.dataset.algoliaObjectId;
    if (!index || !objectID) return null;
    const queryID = productEl.dataset.algoliaQueryId;
    const position = Number(productEl.dataset.algoliaPosition);
    return {
      index,
      objectID,
      productID: productEl.dataset.algoliaProductId,
      position: Number.isFinite(position) && position > 0 ? position : void 0,
      queryID
    };
  }
  function sendAlgoliaClickEvent(element) {
    const analytics = readProductAnalytics(element);
    if (!analytics) return;
    recordClickForPixel(analytics);
    if (analytics.queryID && analytics.position) {
      sendAlgoliaEvent("clickedObjectIDsAfterSearch", {
        eventName: "Product Clicked",
        index: analytics.index,
        objectIDs: [analytics.objectID],
        positions: [analytics.position],
        queryID: analytics.queryID
      });
      return;
    }
    sendAlgoliaEvent("clickedObjectIDs", {
      eventName: "Product Clicked",
      index: analytics.index,
      objectIDs: [analytics.objectID]
    });
  }
  function trackAlgoliaAddToCart(element) {
    const analytics = readProductAnalytics(element);
    if (!analytics) return;
    recordClickForPixel(analytics);
  }

  // src/sections/algolia-main-search/product-card.ts
  var PREFIXED_CURRENCY_SYMBOLS = {
    JPY: "\xA5",
    GBP: "\xA3"
  };
  function escapeHtml(value) {
    return String(value ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
  }
  function escapeAttribute(value) {
    return escapeHtml(value);
  }
  function formatPrice(price) {
    if (price == null) return "";
    try {
      const numericPrice = typeof price === "number" ? price : Number(price);
      const currency = window.currencyIsoCode || window.Shopify?.currency?.active || "EUR";
      const amount = new Intl.NumberFormat(
        document.documentElement.lang || "fr-FR",
        {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2
        }
      ).format(numericPrice);
      const moneyFormat = window.algoliaMoneyFormat;
      if (moneyFormat && moneyFormat.includes("0")) {
        return moneyFormat.replace("0", amount);
      }
      const currencySymbol = new Intl.NumberFormat(document.documentElement.lang || "fr-FR", {
        style: "currency",
        currency,
        currencyDisplay: "narrowSymbol",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).formatToParts(0).find((part) => part.type === "currency")?.value ?? currency;
      if (currencySymbol.includes("$")) {
        const currencyPrefix = currency.slice(0, 2);
        return currencyPrefix === "HK" ? `HK$${amount}` : `${currencyPrefix} $${amount}`;
      }
      const prefixedSymbol = PREFIXED_CURRENCY_SYMBOLS[currency];
      if (prefixedSymbol) {
        return `${prefixedSymbol}${amount}`;
      }
      return `${amount} ${currencySymbol}`;
    } catch {
      return String(price);
    }
  }
  function numericPriceValue(price) {
    if (price == null) return null;
    if (typeof price === "string" && price.trim() === "") return null;
    const numericPrice = typeof price === "number" ? price : Number(price);
    return Number.isFinite(numericPrice) ? numericPrice : null;
  }
  function metaobjectValue(value) {
    if (typeof value === "object" && value !== null) {
      const fieldValue = value.fields?.value;
      if (typeof fieldValue === "string") return fieldValue.trim();
    }
    return "";
  }
  function isSetToComposeProduct(hit) {
    if (String(hit.template_suffix ?? "").trim() === "set-to-compose") {
      return true;
    }
    const bundle = hit.meta?.bundle;
    if (!bundle) return false;
    const pricingMode = String(bundle.pricing_mode ?? "").trim();
    const bundleSize = Number(bundle.size);
    return Boolean(pricingMode) || Number.isFinite(bundleSize) && bundleSize > 0;
  }
  function parseBoolean(value) {
    if (typeof value === "boolean") return value;
    if (typeof value !== "string") return null;
    const normalizedValue = value.trim().toLowerCase();
    if (normalizedValue === "true") return true;
    if (normalizedValue === "false") return false;
    return null;
  }
  function parseJsonValue(value) {
    try {
      return JSON.parse(value);
    } catch {
      return value;
    }
  }
  function nestedValue(value) {
    if (typeof value === "object" && value !== null && "value" in value) {
      return nestedValue(value.value);
    }
    return value;
  }
  function allowedProductsFrom(value) {
    const normalizedValue = nestedValue(value);
    if (Array.isArray(normalizedValue)) return normalizedValue;
    if (typeof normalizedValue !== "string") return [];
    const parsedValue = parseJsonValue(normalizedValue.trim());
    return Array.isArray(parsedValue) ? parsedValue : [];
  }
  function normalizeBundlePrice(value) {
    if (!Number.isFinite(value) || value <= 0) return null;
    return Number.isInteger(value) && value >= 1e3 ? value / 100 : value;
  }
  function priceFromAllowedProduct(value) {
    const normalizedValue = nestedValue(value);
    if (typeof normalizedValue === "number") {
      return normalizeBundlePrice(normalizedValue);
    }
    if (typeof normalizedValue === "string") {
      const parsedNumber = Number(normalizedValue);
      if (Number.isFinite(parsedNumber)) return normalizeBundlePrice(parsedNumber);
      const parsedValue = parseJsonValue(normalizedValue);
      if (parsedValue !== normalizedValue)
        return priceFromAllowedProduct(parsedValue);
      return null;
    }
    if (typeof normalizedValue !== "object" || normalizedValue === null) {
      return null;
    }
    const product = normalizedValue;
    const directPrice = priceFromAllowedProduct(
      product.price ?? product.variant_price ?? product.selected_or_first_available_variant_price
    );
    if (directPrice != null) return directPrice;
    return priceFromAllowedProduct(
      product.selected_or_first_available_variant?.price ?? product.variant?.price ?? product.product?.selected_or_first_available_variant
    );
  }
  function dynamicBundleLowestPrice(hit) {
    const bundle = hit.meta?.bundle;
    if (!bundle) return null;
    const pricingMode = String(bundle.pricing_mode ?? "").trim().toLowerCase();
    const bundleSize = Number(bundle.size);
    if (pricingMode !== "dynamic" || !Number.isFinite(bundleSize) || bundleSize <= 0) {
      return null;
    }
    const allowedPrices = allowedProductsFrom(bundle.allowed_products).map(priceFromAllowedProduct).filter((price) => price != null).sort((firstPrice, secondPrice) => firstPrice - secondPrice);
    if (allowedPrices.length === 0) return null;
    const allowDuplicates = parseBoolean(bundle.allow_duplicates);
    if (allowDuplicates === false) {
      const selectedPrices = allowedPrices.slice(0, bundleSize);
      if (selectedPrices.length < bundleSize) return null;
      return selectedPrices.reduce((total, price) => total + price, 0);
    }
    return allowedPrices[0] * bundleSize;
  }
  function marketPricingKey() {
    const currency = window.Shopify?.currency?.active?.toLowerCase();
    return currency ? `market_pricing_${currency}` : null;
  }
  function productAttributesToRetrieve(base = ALGOLIA_PRODUCT_ATTRIBUTES_TO_RETRIEVE) {
    const key = marketPricingKey();
    return key ? [...base, key] : base;
  }
  function getMarketPrice(hit) {
    const key = marketPricingKey();
    const marketPrice = key ? numericPriceValue(
      hit[key]?.price
    ) : null;
    return marketPrice != null && marketPrice > 0 ? marketPrice : hit.price;
  }
  function renderProductPrice(hit) {
    if (isSetToComposeProduct(hit) && numericPriceValue(hit.price) === 0) {
      return "";
    }
    const bundlePrice = dynamicBundleLowestPrice(hit);
    if (bundlePrice != null) return formatPrice(bundlePrice);
    const price = getMarketPrice(hit);
    return price != 0 ? formatPrice(price) : "";
  }
  function giftProductIdFromGid(gid) {
    const match = /\/Product\/(\d+)/.exec(gid);
    return match ? match[1] : null;
  }
  function giftFromHit(hit) {
    const gift = hit.meta?.custom?.gift_product;
    if (!gift) return null;
    if (typeof gift === "string") {
      const productId = giftProductIdFromGid(gift);
      return productId ? { productId } : null;
    }
    if (typeof gift === "object") {
      if (gift.variant_id != null && gift.variant_id !== "") {
        return { variantId: gift.variant_id, available: gift.available !== false };
      }
      const productId = gift.id ? giftProductIdFromGid(gift.id) : null;
      return productId ? { productId } : null;
    }
    return null;
  }
  function isGiftEligible(hit) {
    return !isSetToComposeProduct(hit) && !Object.is(hit.inventory_available, false);
  }
  function renderGiftLineItemInputs(giftVariantId, parentVariantId) {
    return `
    <input type='hidden' name='items[0][properties][_child]' value='${escapeAttribute(giftVariantId)}'>
    <input type='hidden' name='items[1][id]' value='${escapeAttribute(giftVariantId)}'>
    <input type='hidden' name='items[1][parent_id]' value='${escapeAttribute(parentVariantId)}'>
    <input type='hidden' name='items[1][quantity]' value='1'>
    <input type='hidden' name='items[1][properties][_gift_product]' value='true'>
    <input type='hidden' name='items[1][properties][_parent_id]' value='${escapeAttribute(parentVariantId)}'>`;
  }
  function contenanceOf(hit) {
    const capacity = metaobjectValue(hit.meta?.custom?.capacity);
    if (capacity) return capacity;
    const custom = hit.meta?.custom?.contenance;
    if (typeof custom === "string" && custom) return custom;
    return typeof hit.contenance === "string" ? hit.contenance : "";
  }
  function renderAddToCartInputs(hit, variantId, contenanceLabel) {
    const contenance = contenanceOf(hit);
    const gift = isGiftEligible(hit) ? giftFromHit(hit) : null;
    const giftInputs = gift && "variantId" in gift && gift.available ? renderGiftLineItemInputs(gift.variantId, variantId) : "";
    return `
    <input type='hidden' name='items[0][id]' value='${escapeAttribute(variantId)}'>
    <input type='hidden' name='items[0][quantity]' value='1'>
    ${contenance ? `<input type='hidden' name='items[0][properties][${escapeAttribute(contenanceLabel)}]' value='${escapeAttribute(contenance)}'>` : ""}${giftInputs}`;
  }

  // src/sections/algolia-main-search/gift-product.ts
  var GIFT_SECTION_ID = "gift-product-data";
  var giftCache = /* @__PURE__ */ new Map();
  function routesRoot() {
    const root = window.Shopify?.routes?.root;
    return root && root.length ? root : "/";
  }
  async function fetchGiftForHandle(handle) {
    const base = routesRoot().replace(/\/$/, "");
    const url = `${base}/products/${encodeURIComponent(handle)}?section_id=${GIFT_SECTION_ID}`;
    const response = await fetch(url, { credentials: "same-origin" });
    if (!response.ok) {
      throw new Error(`gift section render failed with status ${response.status}`);
    }
    const html = await response.text();
    const json = new DOMParser().parseFromString(html, "text/html").querySelector("[data-gift-product-json]")?.textContent;
    if (!json) return null;
    const data = JSON.parse(json);
    const variantId = data.variant_id == null || data.variant_id === "" ? "" : String(data.variant_id);
    if (!variantId || data.available === false) return null;
    return { variantId, available: true };
  }
  function resolveGift(handle) {
    let cached = giftCache.get(handle);
    if (!cached) {
      cached = fetchGiftForHandle(handle).catch((error) => {
        console.warn("[gift-product] resolution failed", handle, error);
        return null;
      });
      giftCache.set(handle, cached);
    }
    return cached;
  }
  async function hydrateGiftProducts(root) {
    if (!root) return;
    const forms = Array.from(
      root.querySelectorAll(
        "form[data-gift-parent-handle]:not([data-gift-hydrated])"
      )
    );
    if (forms.length === 0) return;
    await Promise.all(
      forms.map(async (form) => {
        const handle = form.dataset.giftParentHandle;
        const parentId = form.dataset.giftParentId;
        form.dataset.giftHydrated = "true";
        if (!handle || !parentId) return;
        const resolved = await resolveGift(handle);
        if (!resolved || !form.isConnected) return;
        form.insertAdjacentHTML(
          "beforeend",
          renderGiftLineItemInputs(resolved.variantId, parentId)
        );
      })
    );
  }

  // src/shared/utils/section-render.ts
  var SECTION_PREFIX = "shopify-section-";
  function getSectionId(el) {
    if (!el?.id?.startsWith(SECTION_PREFIX)) return null;
    return el.id.slice(SECTION_PREFIX.length);
  }
  function closestSectionId(el) {
    const wrapper = el?.closest(`[id^="${SECTION_PREFIX}"]`);
    return getSectionId(wrapper);
  }
  function collectSectionIds(elements) {
    const ids = /* @__PURE__ */ new Set();
    for (const el of elements) {
      const id = closestSectionId(el);
      if (id) ids.add(id);
    }
    return [...ids];
  }
  function buildUrl(base, params) {
    const url = new URL(base ?? window.location.pathname, window.location.origin);
    for (const [key, value] of Object.entries(params)) {
      url.searchParams.set(key, value);
    }
    return url.toString();
  }
  function withQuery(params, query) {
    if (!query) return params;
    const extra = Object.fromEntries(
      Object.entries(query).map(([k, v]) => [k, String(v)])
    );
    return { ...extra, ...params };
  }
  async function fetchSections(ids, options = {}) {
    const url = buildUrl(
      options.url,
      withQuery({ sections: ids.join(",") }, options.query)
    );
    const response = await fetch(url, { credentials: "same-origin" });
    if (!response.ok) throw new Error(`Sections fetch ${response.status}`);
    return response.json();
  }
  async function fetchSectionHTML(id, options = {}) {
    const url = buildUrl(
      options.url,
      withQuery({ section_id: id }, options.query)
    );
    const response = await fetch(url, { credentials: "same-origin" });
    if (!response.ok) throw new Error(`Section fetch ${response.status}`);
    return response.text();
  }
  function swapInner(html, selector) {
    const selectors = Array.isArray(selector) ? selector : [selector];
    const doc = new DOMParser().parseFromString(html, "text/html");
    selectors.forEach((sel) => {
      document.querySelectorAll(sel).forEach((element) => {
        const source = element.dataset.id ? doc.querySelector(`${sel}[data-id="${element.dataset.id}"]`) : doc.querySelector(sel);
        if (source) element.innerHTML = source.innerHTML;
      });
    });
  }
  function swapSection(id, html) {
    const live = document.getElementById(`${SECTION_PREFIX}${id}`);
    if (!live) return;
    const doc = new DOMParser().parseFromString(html, "text/html");
    const next = doc.getElementById(`${SECTION_PREFIX}${id}`) || doc.body.firstElementChild;
    if (next instanceof HTMLElement) {
      live.replaceWith(next);
    } else {
      live.hidden = true;
    }
  }
  async function renderSections(targets, options = {}) {
    if (targets.length === 0) return;
    const map = options.sections ?? await fetchSections(
      targets.map((t) => t.id),
      options
    );
    for (const target of targets) {
      const html = map[target.id];
      if (typeof html !== "string") continue;
      if (target.selector) {
        swapInner(html, target.selector);
      } else {
        swapSection(target.id, html);
      }
    }
  }
  async function renderSection(target, options = {}) {
    const html = await fetchSectionHTML(target.id, options);
    if (target.selector) {
      swapInner(html, target.selector);
    } else {
      swapSection(target.id, html);
    }
  }

  // src/shared/cart-limit-error/cart-limit-error.ts
  var ERROR_MESSAGE_SELECTOR = "[data-cart-limit-error-message]";
  var ERROR_TEXT_SELECTOR = "[data-cart-limit-error-text]";
  var OPEN_ENGRAVING_PANEL_SELECTOR = "c-engraving-panel.is-open";
  var SEARCH_DIALOG_SELECTOR = "dialog[data-search-dialog]";
  var QUANTITY_LIMIT_PATTERNS = [
    /can'?t add more/i,
    /maximum allowed quantity/i,
    /maximum quantity/i,
    /quantity.*exceeded/i,
    /only add \d+/i
  ];
  function getErrorMessageEl() {
    return document.querySelector(ERROR_MESSAGE_SELECTOR);
  }
  function getDefaultMessage() {
    return window.cartStrings?.addToCartLimitError ?? "The maximum allowed quantity for this product has been exceeded.";
  }
  function isCartQuantityLimitError(status, description) {
    if (status !== 422) return false;
    const normalized = description.trim();
    if (normalized.length === 0) return true;
    return QUANTITY_LIMIT_PATTERNS.some((pattern) => pattern.test(normalized));
  }
  function closeOpenEngravingPanels() {
    document.querySelectorAll(OPEN_ENGRAVING_PANEL_SELECTOR).forEach((panel) => {
      ;
      panel.close();
    });
  }
  function closeHeaderSearchIfOpen() {
    const openDialogs = document.querySelectorAll(
      `${SEARCH_DIALOG_SELECTOR}[open]`
    );
    if (openDialogs.length === 0) return;
    document.documentElement.classList.remove("is-overflow-hidden");
    openDialogs.forEach((dialog) => {
      dialog.close();
    });
  }
  function showCartLimitError(message) {
    closeHeaderSearchIfOpen();
    const errorMessage = getErrorMessageEl();
    if (!errorMessage) return;
    const textEl = errorMessage.querySelector(ERROR_TEXT_SELECTOR);
    if (textEl) {
      textEl.textContent = message ?? getDefaultMessage();
    }
    if (errorMessage.classList.contains("hidden")) {
      errorMessage.classList.remove("hidden");
    }
    closeOpenEngravingPanels();
    window.scrollTo(0, 0);
  }
  function hideCartLimitError() {
    const errorMessage = getErrorMessageEl();
    if (!errorMessage || errorMessage.classList.contains("hidden")) return;
    errorMessage.classList.add("hidden");
  }

  // src/snippets/product-form/product-form.ts
  var CProductForm = class extends HTMLElement {
    constructor() {
      super();
      this.SELECTORS = {
        form: "form",
        submitButton: 'button[type="submit"]',
        updatesInput: 'input[name^="updates["]',
        qtyButton: "[data-qty-btn]",
        notifyMeButton: "[data-notify-me-button]",
        notifyWidget: '.gw-float-widget[type="button"]',
        loaderId: "full-page-loader",
        cartRecommendRoot: "[data-cart-recommend-root]",
        // Section `cart-samples` : ancre stable du wrapper + les deux blocs internes.
        samplesSection: "[data-samples-section]",
        samplesRoot: "[data-cart-samples]",
        packagingRoot: "[data-cart-packaging]",
        // Targets re-render via l'Ajax Section Rendering API.
        headerCartLink: ".header__action-link--cart",
        popupAtcContainer: "[data-popup-atc-container]",
        cartItems: "[data-cart-items]",
        engravingPanelCart: ".engraving-panel-container-cart",
        cartSummary: "[data-cart-summary]",
        // Wrapper `#shopify-section-…` de la section cart-summary : présent même
        // quand le panier est vide (le contenu interne, lui, est conditionné par
        // `cart.item_count`), donc plus fiable que `[data-cart-summary]` pour
        // retrouver l'id de section.
        cartSummarySection: ".section-cart-summary"
      };
      this.quantitySnapshot = null;
      this.submitForm = async () => {
        if (!this.form) return;
        this.clearCartError();
        const hiddenElements = Array.from(
          this.form.querySelectorAll("input, select, textarea")
        ).filter(
          (el) => el.offsetParent === null && el.type !== "hidden"
        );
        hiddenElements.forEach((el) => {
          el.disabled = true;
        });
        const formData = new FormData(this.form);
        hiddenElements.forEach((el) => {
          el.disabled = false;
        });
        const config = this.fetchConfig("javascript");
        const targets = this.isCart ? this.getCartPageTargets() : this.sectionsRender;
        const sectionsParam = targets.map((target) => target.id).join(",");
        formData.set("sections", sectionsParam);
        if (this.action === "change" && this.itemKey) {
          const properties = {};
          for (const [key, value] of formData.entries()) {
            if (key.includes("properties")) {
              const propKey = key.match(/\[(.*?)\]/g)?.pop()?.replace(/[\[\]]/g, "");
              if (propKey) properties[propKey] = value;
            }
          }
          config.body = JSON.stringify({
            id: this.itemKey,
            properties,
            sections: sectionsParam
          });
        } else {
          config.body = formData;
          delete config.headers["Content-Type"];
        }
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        try {
          const endpoints = {
            add: "cart/add.js",
            change: "cart/change.js",
            update: "cart/update.js",
            remove: "cart/update.js"
          };
          const endpoint = endpoints[this.action] ?? endpoints["add"];
          const response = await fetch(
            (window.Shopify?.routes?.root || "/") + endpoint,
            config
          );
          if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            const rawMessage = errorData.description || errorData.message || `Erreur ${response.status}`;
            const message = this.errorMessages[rawMessage] || rawMessage;
            if (isCartQuantityLimitError(response.status, rawMessage)) {
              showCartLimitError();
            } else {
              showCartLimitError(message);
            }
            throw new Error(message);
          }
          const data = await response.json();
          hideCartLimitError();
          this.quantitySnapshot = null;
          await renderSections(targets, { sections: data.sections });
          this.dispatchEvent(
            new CustomEvent("cart:add-success", {
              bubbles: true,
              detail: { data, action: this.action }
            })
          );
          if (this.isCart) {
            this.renderSampleSection();
            await this.rerenderCartRecommendSections();
          }
        } catch (error) {
          this.restoreQuantitySnapshot();
          console.error(error.message);
        }
      };
      this.form = this.querySelector(this.SELECTORS.form);
      this.countCartItems = this.dataset.countCartItems || null;
      this.formId = this.form?.id || null;
      this.btnSubmit = this.querySelector(this.SELECTORS.submitButton);
      this.btnSubmitAlreadyInfos = document.querySelector(
        `button[form="${this.formId}"]`
      );
      this.type = this.dataset.type || null;
      this.isCart = this.dataset.isCart || null;
      this.itemKey = this.dataset.itemKey || null;
      this.action = this.dataset.action || "add";
      this.errorMessages = {
        error_product_gift_cart: this.dataset.errorProductGiftCart || ""
      };
      this.samplesSectionId = this.getSamplesSectionId();
      this.sectionsRenderSamples = this.samplesSectionId ? [
        {
          id: this.samplesSectionId,
          selector: [
            this.SELECTORS.samplesRoot,
            this.SELECTORS.packagingRoot
          ]
        }
      ] : [];
      this.sectionsRender = [
        { id: "header", selector: [this.SELECTORS.headerCartLink] },
        { id: "popup-add-to-cart", selector: [this.SELECTORS.popupAtcContainer] }
      ];
    }
    getSamplesSectionId() {
      const sectionChild = document.querySelector(this.SELECTORS.samplesSection);
      return closestSectionId(sectionChild);
    }
    getCartSummarySectionId() {
      return closestSectionId(
        document.querySelector(this.SELECTORS.cartSummarySection)
      ) ?? closestSectionId(document.querySelector(this.SELECTORS.cartSummary));
    }
    // Page panier éclatée en plusieurs sections empilées. Les ids sont résolus au
    // moment du submit (et non dans le constructeur) : le wrapper cart-summary
    // peut être absent ou remplacé entre deux mutations du panier, et l'id réel
    // dépend de templates/cart.json (l'éditeur de thème peut le suffixer).
    getCartPageTargets() {
      const cartSummarySectionId = this.getCartSummarySectionId();
      return [
        { id: "header", selector: [this.SELECTORS.headerCartLink] },
        { id: "popup-add-to-cart", selector: [this.SELECTORS.popupAtcContainer] },
        {
          id: "main-cart",
          selector: [this.SELECTORS.cartItems, this.SELECTORS.engravingPanelCart]
        },
        // Outer swap (pas de `selector`) : le contenu de cart-summary est gated
        // par `cart.item_count`, un inner swap ne saurait pas passer de vide à
        // non-vide (et inversement).
        ...cartSummarySectionId ? [{ id: cartSummarySectionId }] : []
      ];
    }
    connectedCallback() {
      this.initNotifyMe();
      this.checkNotifyMeHash();
      this.form?.addEventListener("submit", async (e) => {
        if (!this.form) return;
        e.preventDefault();
        if (this.btnSubmit) this.btnSubmit.setAttribute("disabled", "true");
        if (this.btnSubmitAlreadyInfos)
          this.btnSubmitAlreadyInfos.setAttribute("disabled", "true");
        const loader = document.getElementById(this.SELECTORS.loaderId);
        if (loader) loader.setAttribute("aria-hidden", "false");
        await this.submitForm();
        if (loader) loader.setAttribute("aria-hidden", "true");
        if (this.btnSubmit) this.btnSubmit.removeAttribute("disabled");
        if (this.btnSubmitAlreadyInfos)
          this.btnSubmitAlreadyInfos.removeAttribute("disabled");
      });
      if (this.action === "update") {
        this.form?.querySelectorAll('input[name^="updates["]').forEach((input) => {
          input.addEventListener("focus", () => {
            this.captureQuantitySnapshot();
          });
        });
      }
      this.form?.addEventListener("change", (e) => {
        const target = e.target;
        if (target.name.includes("updates[")) {
          this.form?.requestSubmit();
        }
      });
      this.form?.addEventListener("click", (e) => {
        const button = e.target.closest(
          this.SELECTORS.qtyButton
        );
        if (!button || !this.form) return;
        e.preventDefault();
        const step = parseInt(button.getAttribute("data-qty-step") || "0", 10);
        const inputs = this.form.querySelectorAll(this.SELECTORS.updatesInput);
        let blockedByLimit = false;
        this.captureQuantitySnapshot();
        inputs.forEach((input) => {
          const el = input;
          const currentVal = parseInt(el.value || "0", 10);
          const maxAttr = el.getAttribute("max");
          const maxQuantity = maxAttr ? parseInt(maxAttr, 10) : Number.NaN;
          const nextVal = currentVal + step;
          if (step > 0 && Number.isFinite(maxQuantity) && nextVal > maxQuantity) {
            blockedByLimit = true;
            return;
          }
          el.value = Math.max(0, nextVal).toString();
        });
        if (blockedByLimit) {
          this.quantitySnapshot = null;
          showCartLimitError();
          return;
        }
        this.form.requestSubmit();
      });
    }
    /**
     * If the product is unavailable, the form renders an `<a data-notify-me-button>` link
     * instead of a submit button. This method polls for the third-party notify-me widget
     * and proxies clicks from our button to that widget.
     */
    initNotifyMe() {
      const notifyMeBtn = this.querySelector(this.SELECTORS.notifyMeButton);
      if (!notifyMeBtn) return;
      const href = notifyMeBtn.getAttribute("href") || "";
      if (href && !href.includes("#notify-me")) {
        notifyMeBtn.setAttribute("href", `${href}#notify-me`);
      }
      const bindNotifyWidget = (retries = 20, interval = 300) => {
        const widget = document.querySelector(
          this.SELECTORS.notifyWidget
        );
        if (widget) {
          widget.style.display = "none";
          notifyMeBtn.addEventListener("click", (event) => {
            event.preventDefault();
            widget.click();
          });
        } else if (retries > 0) {
          setTimeout(() => bindNotifyWidget(retries - 1, interval), interval);
        }
      };
      bindNotifyWidget();
    }
    /**
     * When landing on a product page with `#notify-me` in the URL (e.g. from a
     * collection card), auto-open the third-party notify-me widget.
     */
    checkNotifyMeHash() {
      if (window.location.hash !== "#notify-me") return;
      const autoOpenNotifyWidget = (retries = 20, interval = 300) => {
        const widget = document.querySelector(
          this.SELECTORS.notifyWidget
        );
        if (widget) {
          widget.click();
          history.replaceState(
            null,
            "",
            window.location.pathname + window.location.search
          );
        } else if (retries > 0) {
          setTimeout(() => autoOpenNotifyWidget(retries - 1, interval), interval);
        }
      };
      autoOpenNotifyWidget();
    }
    // Re-render la section `cart-samples` via l'Ajax Section Rendering API
    // (`?section_id=`) puis swap les blocs samples + packaging. Reload complet en
    // cas d'erreur.
    async renderSampleSection() {
      try {
        for (const section of this.sectionsRenderSamples) {
          await renderSection(section);
        }
      } catch (error) {
        console.error("[CartSamples] section render error:", error);
        window.location.reload();
      }
    }
    captureQuantitySnapshot() {
      if (!this.form || this.action !== "update") return;
      this.quantitySnapshot = /* @__PURE__ */ new Map();
      this.form.querySelectorAll(this.SELECTORS.updatesInput).forEach((input) => {
        this.quantitySnapshot.set(input.name, input.value);
      });
    }
    restoreQuantitySnapshot() {
      if (!this.form || !this.quantitySnapshot) return;
      this.form.querySelectorAll(this.SELECTORS.updatesInput).forEach((input) => {
        const saved = this.quantitySnapshot.get(input.name);
        if (saved !== void 0) input.value = saved;
      });
      this.quantitySnapshot = null;
    }
    clearCartError() {
      hideCartLimitError();
    }
    fetchConfig(type = "json") {
      return {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: `application/${type}`
        }
      };
    }
    // Outer swap des sections de recommandations : on collecte les ids des
    // wrappers `#shopify-section-…` autour de chaque `[data-cart-recommend-root]`
    // puis on remplace chaque wrapper par sa version fraîche.
    async rerenderCartRecommendSections() {
      const roots = document.querySelectorAll(this.SELECTORS.cartRecommendRoot);
      const sectionIds = collectSectionIds(roots);
      if (sectionIds.length === 0) return;
      await renderSections(sectionIds.map((id) => ({ id })));
    }
    disconnectedCallback() {
    }
  };
  if (!customElements.get("c-product-form")) {
    customElements.define("c-product-form", CProductForm);
  }

  // src/shared/algolia-rule-push/algolia-rule-push.ts
  function isRecord(value) {
    return value !== null && typeof value === "object";
  }
  function asString(value) {
    return typeof value === "string" ? value.trim() : "";
  }
  function escapeHtml2(value) {
    return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
  }
  function escapeAttribute2(value) {
    return escapeHtml2(value);
  }
  function localizedRoot() {
    return window.Shopify?.routes?.root ?? "/";
  }
  function joinRootUrl(root, path) {
    return `${root.replace(/\/$/, "")}/${path.replace(/^\//, "")}`;
  }
  function normalizeUrl(value) {
    if (!value) return "";
    if (value.startsWith("#") || value.startsWith("http://") || value.startsWith("https://")) {
      return value;
    }
    if (!value.startsWith("/")) return "";
    const root = localizedRoot();
    if (root === "/" || value.startsWith(root)) return value;
    return joinRootUrl(root, value);
  }
  function parseUserDataItem(item) {
    if (typeof item !== "string") return item;
    try {
      return JSON.parse(item);
    } catch {
      return item;
    }
  }
  function normalizeUserData(userData) {
    const parsedUserData = parseUserDataItem(userData);
    if (Array.isArray(parsedUserData)) {
      return parsedUserData.flatMap(normalizeUserData);
    }
    if (!isRecord(parsedUserData)) return [];
    const list = parsedUserData;
    const nestedList = [list.push, list.pushes, list.items, list.rules].find(
      Array.isArray
    );
    if (nestedList) return normalizeUserData(nestedList);
    return [parsedUserData];
  }
  function normalizeOrder(value) {
    const order = typeof value === "number" ? value : Number(value);
    if (!Number.isInteger(order) || order < 1) return null;
    return order;
  }
  function normalizeStyle(value, fallback) {
    return value || fallback;
  }
  function normalizeButtonType(item) {
    return normalizeStyle(
      asString(item.button?.button_type) || asString(item.button?.button_style),
      "v-primary"
    );
  }
  function normalizeButtonSize(item) {
    return normalizeStyle(asString(item.button?.button_size), "v-large");
  }
  function normalizeButtonVariant(item) {
    return normalizeStyle(asString(item.button?.button_variant), "v-dark");
  }
  function normalizeRulePush(item) {
    const buttonUrl = normalizeUrl(asString(item.button?.button_url));
    const linkUrl = normalizeUrl(asString(item.link?.link_url));
    const visualLink = normalizeUrl(asString(item.visualLink));
    const ctaLink = normalizeUrl(asString(item.ctaLinkLink));
    return {
      buttonLabel: asString(item.button?.button_label) || asString(item.ctaLinkText) || "D\xE9couvrir",
      buttonSize: normalizeButtonSize(item),
      buttonType: normalizeButtonType(item),
      buttonUrl: buttonUrl || ctaLink || linkUrl || visualLink || "#",
      buttonVariant: normalizeButtonVariant(item),
      description: asString(item.content?.description) || asString(item.descr) || asString(item.description),
      imageDesktop: asString(item.media?.media_desktop) || asString(item.visual?.url) || asString(item.visualDesktop),
      imageMobile: asString(item.media?.media_mobile),
      linkLabel: asString(item.link?.link_label),
      linkStyle: normalizeStyle(asString(item.link?.link_style), "v-primary"),
      linkUrl: linkUrl || buttonUrl || ctaLink || visualLink || "#",
      order: normalizeOrder(item.order),
      ratioDesktop: asString(item.media?.ratio_desktop),
      ratioMobile: asString(item.media?.ratio_mobile),
      sectionHeading: asString(item.sectionHeading),
      title: asString(item.content?.title) || asString(item.heading) || asString(item.title)
    };
  }
  function getRulePushes(userData) {
    return normalizeUserData(userData).map(normalizeRulePush).filter(
      (item) => item.title || item.description || item.imageDesktop || item.buttonUrl !== "#" || item.linkUrl !== "#"
    ).sort(
      (a, b) => (a.order ?? Number.MAX_SAFE_INTEGER) - (b.order ?? Number.MAX_SAFE_INTEGER)
    );
  }
  function renderRulePushIconic(push) {
    const title = escapeHtml2(push.title);
    const url = escapeAttribute2(
      push.buttonUrl !== "#" ? push.buttonUrl : push.linkUrl
    );
    const label = push.linkLabel || push.buttonLabel;
    const imageDesktop = escapeAttribute2(push.imageDesktop);
    const imageMobile = escapeAttribute2(push.imageMobile);
    const mediaHtml = imageDesktop ? `<a aria-label='${title}' href='${url}'>
        <span>
          <picture>
            ${imageMobile ? `<source media='(max-width: 767px)' srcset='${imageMobile}'>` : ""}
            <img src='${imageDesktop}' alt='${title}' loading='lazy'>
          </picture>
        </span>
      </a>` : "";
    return `<div class='block-push-iconics__push'>
    ${mediaHtml}
    <div class='push__text'>
      ${push.title ? `<span class='label-s-alternate'>${title}</span>` : ""}
      ${push.description ? `<span class='body-s-light color-secondary'>${push.description}</span>` : ""}
      ${label ? `<a aria-label='${escapeAttribute2(label)}' class='push__link label-s-regular button-primary--link m-0 w-fit' href='${url}'>
        <span class='button__label'>${escapeHtml2(label)}</span>
      </a>` : ""}
    </div>
  </div>`;
  }
  function renderRulePushIconics(userData) {
    return getRulePushes(userData).map(renderRulePushIconic).join("");
  }

  // src/sections/algolia-header-search/constants.ts
  var CDN_AUTOCOMPLETE_JS = "https://cdn.jsdelivr.net/npm/@algolia/autocomplete-js@1.19.9/dist/umd/index.production.js";
  var SRI_AUTOCOMPLETE_JS = "sha384-DAsLIoO0iXMCy0HaVwPa7s4Jl+E1ss/6/hvlw/PTKnj1E8Qu5vfEyBqMtXYNhytY";
  var MAX_PREDICTIVE_QUERIES = 4;
  var RECENT_SEARCHES_KEY = "diptyque:algolia-header-search:recent-searches";
  var MAX_RECENT_SEARCHES = 3;
  var PRODUCT_ATTRIBUTES_TO_RETRIEVE = [
    "objectID",
    "id",
    "handle",
    "url",
    "title",
    "image",
    "meta",
    "subtitle",
    "price",
    "available",
    "inventory_available",
    "variant_id",
    "template_suffix"
  ];
  var SIDEBAR_ATTRIBUTES_TO_RETRIEVE = [
    "objectID",
    "handle",
    "title",
    "url",
    "type",
    "object_type"
  ];
  var QUERY_ATTRIBUTES_TO_RETRIEVE = [
    "objectID",
    "query",
    "meta",
    "title",
    "url"
  ];

  // src/sections/algolia-header-search/algolia-header-search.ts
  var productCardIndex = 0;
  function parseShortQueries(value) {
    return (value ?? "").split(/[\n,]/).map((item) => item.trim().toLowerCase()).filter(Boolean);
  }
  function minimumQueryLength(query, shortQueries) {
    const normalizedQuery = query.trim().toLowerCase();
    if (shortQueries.includes(normalizedQuery)) return normalizedQuery.length;
    return MIN_QUERY_LEN;
  }
  function readHeaderSearchConfig(el) {
    const {
      algoliaAppId,
      algoliaApiKey,
      algoliaIndexProducts = "products",
      algoliaIndexSections = "sections",
      algoliaIndexSuggestions = "",
      algoliaShortQueries,
      contenanceLabel = "Contenance",
      isCartPage,
      searchPlaceholder = ""
    } = el.dataset;
    if (!algoliaAppId || !algoliaApiKey) return null;
    return {
      apiKey: algoliaApiKey,
      appId: algoliaAppId,
      contenanceLabel,
      isCartPage: isCartPage === "true",
      indexes: {
        products: algoliaIndexProducts,
        sections: algoliaIndexSections,
        suggestions: algoliaIndexSuggestions
      },
      placeholder: searchPlaceholder,
      shortQueries: parseShortQueries(algoliaShortQueries)
    };
  }
  function escapeHtml3(value) {
    return String(value ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
  }
  function shopifyRoot() {
    return window.Shopify?.routes?.root ?? "/";
  }
  function itemUrl(hit) {
    if (hit.url) return hit.url;
    if (!hit.handle) return "#";
    const root = shopifyRoot();
    const isCollection = [
      hit.type,
      hit.object_type,
      String(hit.objectID ?? "").includes("/Collection/") ? "collection" : ""
    ].includes("collection");
    return `${root}${isCollection ? "collections" : "products"}/${hit.handle}`;
  }
  function searchUrlFor(query) {
    const root = shopifyRoot();
    const normalizedRoot = root.endsWith("/") ? root : `${root}/`;
    return `${normalizedRoot}search?q=${encodeURIComponent(query)}`;
  }
  function readRecentSearches() {
    try {
      const rawItems = JSON.parse(
        window.localStorage.getItem(RECENT_SEARCHES_KEY) ?? "[]"
      );
      if (!Array.isArray(rawItems)) return [];
      return rawItems.filter((item) => typeof item === "string").map((item) => item.trim()).filter(Boolean).slice(0, MAX_RECENT_SEARCHES);
    } catch {
      return [];
    }
  }
  function writeRecentSearch(query) {
    const normalizedQuery = query.trim();
    if (!normalizedQuery) return;
    const nextItems = [
      normalizedQuery,
      ...readRecentSearches().filter(
        (item) => item.toLowerCase() !== normalizedQuery.toLowerCase()
      )
    ].slice(0, MAX_RECENT_SEARCHES);
    try {
      window.localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(nextItems));
    } catch {
    }
  }
  function renderRecentSearches(container, iconMarkup, query = "") {
    if (!container) return;
    const normalizedQuery = query.trim().toLowerCase();
    const items = normalizedQuery ? readRecentSearches().filter(
      (item) => item.toLowerCase().startsWith(normalizedQuery)
    ) : [];
    if (!items.length) {
      container.hidden = true;
      container.innerHTML = "";
      return;
    }
    container.innerHTML = `
    <ul class='header-search__recent-list'>
      ${items.map(
      (item) => `
            <li>
              <a href='${searchUrlFor(item)}' class='label-m-light'>
                <span class='header-search__recent-icon' aria-hidden='true'>${iconMarkup}</span>
                <span>${escapeHtml3(item)}</span>
              </a>
            </li>`
    ).join("")}
    </ul>`;
    container.hidden = false;
  }
  function renderAnalyticsAttributes(hit, indexName, queryID, position) {
    if (hit.objectID == null) return "";
    return [
      "data-algolia-product",
      `data-algolia-index='${escapeHtml3(indexName)}'`,
      `data-algolia-object-id='${escapeHtml3(hit.objectID)}'`,
      hit.id != null ? `data-algolia-product-id='${escapeHtml3(hit.id)}'` : "",
      queryID ? `data-algolia-query-id='${escapeHtml3(queryID)}'` : "",
      `data-algolia-position='${escapeHtml3(position)}'`
    ].filter(Boolean).join(" ");
  }
  function highlightRemaining(title, query) {
    const lowerTitle = title.toLowerCase();
    const lowerQuery = query.trim().toLowerCase();
    if (!lowerQuery) return escapeHtml3(title);
    const idx = lowerTitle.indexOf(lowerQuery);
    if (idx === -1) return escapeHtml3(title);
    const matchEnd = idx + lowerQuery.length;
    const before = escapeHtml3(title.slice(0, matchEnd));
    const remaining = escapeHtml3(title.slice(matchEnd));
    return remaining ? `${before}<em>${remaining}</em>` : escapeHtml3(title);
  }
  function renderSidebarSection(title, items) {
    return `
    <div class='algolia-sidebar__section'>
      <span class='label-m-alternate'>${title}</span>
      <ul class='algolia-sidebar__list'>
        ${items.join("")}
      </ul>
    </div>`;
  }
  function renderProductTags(tags = []) {
    const tagLabels = tags.map((tag) => tag.fields?.name).filter((name) => Boolean(name));
    if (tagLabels.length === 0) return "";
    return `<div class='product-card__tags-container'>
      ${tagLabels.map((name) => `<span class='product-card__tag label-s-regular'>${escapeHtml3(name)}</span>`).join("")}
    </div>`;
  }
  function renderProductCard(hit, indexName, queryID, position, contenanceLabel, isCartPage) {
    const url = itemUrl(hit);
    const title = hit.title ?? "";
    const subtitle = hit.meta?.custom?.subtitle ?? hit.subtitle ?? "";
    const available = !Object.is(hit.inventory_available, false);
    const variantId = hit.variant_id ?? hit.objectID ?? "";
    const productId = hit.id ?? "";
    const formId = `algolia-card-${++productCardIndex}`;
    const imageHtml = hit.image ? `<div class='product-card__image'>
        <img src='${escapeHtml3(hit.image)}' alt='${escapeHtml3(hit.title ?? "")}' class='product-card__image-item' loading='lazy' width='300' height='300'>
      </div>` : `<div class='product-card__image'></div>`;
    const productPrice = renderProductPrice(hit);
    const priceHtml = productPrice ? `<div class='product-card__price-container'>
          <span class='product-card__price label-m-regular'>${escapeHtml3(productPrice)}</span>
        </div>` : "";
    const isSetToCompose = isSetToComposeProduct(hit);
    const gift = isGiftEligible(hit) ? giftFromHit(hit) : null;
    const cartInputs = renderAddToCartInputs(hit, variantId, contenanceLabel);
    const giftFormAttr = gift && "productId" in gift && hit.handle ? ` data-gift-parent-handle='${escapeHtml3(hit.handle)}' data-gift-parent-id='${escapeHtml3(variantId)}'` : "";
    const sectionsToRender = isCartPage ? "header,popup-add-to-cart,cart-samples,cart-summary,main-cart" : "header,popup-add-to-cart";
    const isCartAttr = isCartPage ? ` data-is-cart='true'` : "";
    const strings = window.variantStrings;
    const notifyUrl = url.includes("#notify-me") ? url : `${url}#notify-me`;
    const buttonHtml = !available ? `<a class='button button-primary button--header-search' href='${escapeHtml3(notifyUrl)}' data-algolia-click>
        <span>${strings?.notify_me ?? "Notify me"}</span>
      </a>` : isSetToCompose ? `<a class='button button-primary button--header-search' href='${escapeHtml3(url)}' data-algolia-click>
        <span>${strings?.set_to_compose ?? "Create this set"}</span>
      </a>` : `<button type='submit' class='button product-form__submit button-primary--link' data-product-form-submit data-algolia-convert>
        <span class='product-form__submit-text button__label'>
          ${ICON_BULLET}
          <span>${strings?.addToCart ?? "Add to cart"}</span>
          ${ICON_BULLET}
        </span>
      </button>`;
    return `
    <div class='product-card align-center' ${renderAnalyticsAttributes(hit, indexName, queryID, position)}>
      ${renderProductTags(hit.meta?.custom?.product_tags)}
      <a href='${escapeHtml3(url)}' class='product-card__link' data-algolia-click>
        ${imageHtml}
      </a>
      <div class='product-card__container'>
        <div class='product-card__content'>
          <a href='${escapeHtml3(url)}' data-algolia-click>
            <h3 class='product-card__title label-m-alternate'>${escapeHtml3(title)}</h3>
            <p class='product-card__subtitle body-m-light color-secondary'>${escapeHtml3(subtitle)}</p>
          </a>
          ${priceHtml}
        </div>
        <div class='product-card__button'>
          <div class='product-form'>
            <c-product-form
              class='product-form__form'
              data-action='add'
              data-product-id='${productId}'
              data-variant-id='${variantId}'${isCartAttr}
            >
              <form id='${formId}' class='form' action='/cart/add' method='post' novalidate data-type='add-to-cart-form'${giftFormAttr}>
                <input type='hidden' value='${sectionsToRender}' name='sections'>
                ${cartInputs}
                ${buttonHtml}
                <div class='product-form__error' data-product-form-error style='display:none;'></div>
                <script type='application/ld+json' style='display:none;' data-structured-data-product>[{"id":${JSON.stringify(variantId)}}]<\/script>
              </form>
            </c-product-form>
          </div>
        </div>
      </div>
    </div>`;
  }
  function renderProductsHtml(config, hits, nbHits, query, queryID) {
    return `
    <div class='header-search__product-result is-open'>
      <div class='result-title'>
        <span class='label-m-alternate'>Products (${nbHits})</span>
        <a href='${shopifyRoot()}search?q=${encodeURIComponent(query)}&type=product' class='link v-secondary m-0 w-fit'>
          <span class='cta--label'>
            <span class='cta--label__text'>See all</span>
          </span>
        </a>
      </div>
      <div class='container-result'>
        ${hits.map(
      (hit, index) => renderProductCard(
        hit,
        config.indexes.products,
        queryID,
        index + 1,
        config.contenanceLabel,
        config.isCartPage
      )
    ).join("")}
      </div>
    </div>`;
  }
  function renderQueriesHtml(hits, query) {
    if (!hits.length) return "";
    return `
    <ul class='predictive-queries'>
      ${hits.slice(0, MAX_PREDICTIVE_QUERIES).map((hit) => {
      const suggestionQuery = String(hit.query ?? hit.objectID ?? "");
      const title = hit.title ?? suggestionQuery;
      const url = searchUrlFor(title);
      return `<li>
            <a href='${url}' tabindex='-1'>
              <p class='body-m-light' aria-label='${escapeHtml3(suggestionQuery)}'>${highlightRemaining(title, query)}</p>
            </a>
          </li>`;
    }).join("")}
    </ul>`;
  }
  function renderSectionsHtml(config, hits, queryID) {
    if (!hits.length) return "";
    return renderSidebarSection(
      "Sections",
      hits.map(
        (hit, index) => `<li ${renderAnalyticsAttributes(hit, config.indexes.sections, queryID, index + 1)}>
        <a href='${escapeHtml3(itemUrl(hit))}' class='algolia-sidebar__link' data-algolia-click>
          <span class='label-m-regular'>${escapeHtml3(hit.title ?? "")}</span>
          <span><svg xmlns='http://www.w3.org/2000/svg' width='3' height='5' viewBox='0 0 3 5' fill='none'><path d='M3 2.25L0 0V4.5L3 2.25Z' fill='black'/></svg></span>
        </a>
      </li>`
      )
    );
  }
  function renderExploreHtml(userData) {
    const exploreHtml = renderRulePushIconics(userData);
    return exploreHtml ? `<div class='block-push-iconics'>
        <span class='block-push-iconics__title label-m-alternate'>Explore</span>
        <div class='inside remove-scroll-bar'>
          <div class='block-push-iconics__container'>${exploreHtml}</div>
        </div>
      </div>` : "";
  }
  var autocompleteModulePromise = null;
  function loadAutocompleteModule() {
    if (!autocompleteModulePromise) {
      autocompleteModulePromise = loadScript(
        CDN_AUTOCOMPLETE_JS,
        SRI_AUTOCOMPLETE_JS
      ).then(() => {
        const mod = window["@algolia/autocomplete-js"];
        if (!mod) throw new Error("Algolia Autocomplete library is not available");
        return mod;
      });
    }
    return autocompleteModulePromise;
  }
  var searchClientPromise = null;
  var searchClientKey = "";
  function loadSearchClient(appId, apiKey) {
    const key = `${appId}:${apiKey}`;
    if (!searchClientPromise || searchClientKey !== key) {
      searchClientKey = key;
      searchClientPromise = loadScript(CDN_ALGOLIASEARCH, SRI_ALGOLIASEARCH).then(
        () => {
          const lib = window["algoliasearch/lite"];
          if (!lib) throw new Error("Algolia lite client is not available");
          return lib.liteClient(appId, apiKey);
        }
      );
    }
    return searchClientPromise;
  }
  var debounceTimer = null;
  var debounceResolvers = [];
  function waitForDebounce() {
    return new Promise((resolve) => {
      debounceResolvers.push(resolve);
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        debounceTimer = null;
        const resolvers = debounceResolvers;
        debounceResolvers = [];
        resolvers.forEach((fn) => fn());
      }, SEARCH_DEBOUNCE_MS);
    });
  }
  function navigateTo(url) {
    if (!url || url === "#") return;
    let target;
    try {
      target = new URL(url, window.location.origin);
    } catch {
      return;
    }
    if (target.protocol !== "https:" && target.protocol !== "http:") return;
    if (target.origin !== window.location.origin) return;
    window.location.assign(target.href);
  }
  function itemsForSource(state, sourceId) {
    return state.collections.find((c) => c.source.sourceId === sourceId)?.items ?? [];
  }
  var AlgoliaHeaderSearch = class extends HTMLElement {
    constructor() {
      super(...arguments);
      this.abortController = null;
      this.autocompleteInstance = null;
      this.config = null;
      this.dialog = null;
      this.root = null;
      this.panel = null;
      this.panelSink = null;
      this.emptyState = null;
      this.recentSearches = null;
      this.iconMarkup = "";
      this.searchIconMarkup = "";
      this.handleKeydown = (event) => {
        if (event.key === "Escape" && this.dialog?.open) {
          event.preventDefault();
          this.toggleDialog();
        }
        if (event.key === "k" && (event.metaKey || event.ctrlKey)) {
          event.preventDefault();
          this.toggleDialog();
        }
      };
      this.handleClick = (event) => {
        if (!(event.target instanceof Element)) return;
        const clickEl = event.target.closest("[data-algolia-click]");
        if (clickEl) sendAlgoliaClickEvent(clickEl);
      };
      this.handleSubmit = (event) => {
        if (!(event.target instanceof Element)) return;
        const conversionEl = event.target.closest("[data-algolia-product]");
        if (conversionEl) trackAlgoliaAddToCart(conversionEl);
      };
      this.toggleDialog = () => {
        if (!this.dialog) return;
        if (this.dialog.open) {
          this.closeDialog();
          return;
        }
        document.documentElement.classList.add("is-overflow-hidden");
        this.dialog.showModal();
        void this.ensureAutocomplete();
      };
      // Ajout au panier réussi (événement bubblé par `<c-product-form>` dans le panneau) :
      // on ferme la recherche pour révéler le popup panier / la page cart re-rendue. Le
      // rafraîchissement des sections (main-cart, cart-summary, header…) est géré par
      // CProductForm via `data-is-cart` + la liste `sections` du formulaire.
      this.handleAddSuccess = () => {
        this.closeDialog();
      };
    }
    connectedCallback() {
      this.config = readHeaderSearchConfig(this);
      this.dialog = this.querySelector("[data-search-dialog]");
      this.root = this.querySelector("[data-autocomplete-root]");
      this.panel = this.querySelector("[data-algolia-panel]");
      this.emptyState = this.querySelector("[data-empty-state]");
      this.recentSearches = this.querySelector("[data-recent-searches]");
      this.iconMarkup = this.querySelector(
        "template[data-recent-search-icon]"
      )?.innerHTML.trim() ?? "";
      this.searchIconMarkup = this.querySelector(
        "template[data-search-icon]"
      )?.innerHTML.trim() ?? "";
      this.bindEvents();
      this.showEmptyState();
    }
    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
      this.autocompleteInstance?.destroy();
      this.autocompleteInstance = null;
    }
    bindEvents() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const { signal } = this.abortController;
      document.querySelectorAll("[data-btn-toogle-search]").forEach(
        (button) => button.addEventListener("click", this.toggleDialog, { signal })
      );
      this.addEventListener("click", this.handleClick, { signal });
      this.addEventListener("submit", this.handleSubmit, {
        capture: true,
        signal
      });
      this.addEventListener("cart:add-success", this.handleAddSuccess, { signal });
      window.addEventListener("keydown", this.handleKeydown, { signal });
    }
    closeDialog() {
      if (!this.dialog?.open) return;
      document.documentElement.classList.remove("is-overflow-hidden");
      this.dialog.close();
    }
    showEmptyState() {
      this.dataset.state = "empty";
      this.emptyState?.removeAttribute("hidden");
    }
    showResultsState(hasResults) {
      this.dataset.state = hasResults ? "results" : "no-results";
      this.emptyState?.setAttribute("hidden", "");
    }
    buildGetSources(config) {
      return ({
        query,
        setContext
      }) => {
        const minLength = minimumQueryLength(query, config.shortQueries);
        if (!query || query.length < minLength) return [];
        const insightsParams = {
          analyticsTags: ["header-search"],
          clickAnalytics: true,
          userToken: getAlgoliaUserToken()
        };
        const runQuery = async (indexName, hitsPerPage, attributesToRetrieve, onResult) => {
          await waitForDebounce();
          const [searchClient, { getAlgoliaResults }] = await Promise.all([
            loadSearchClient(config.appId, config.apiKey),
            loadAutocompleteModule()
          ]);
          return getAlgoliaResults({
            queries: [
              {
                indexName,
                params: {
                  query,
                  hitsPerPage,
                  attributesToHighlight: [],
                  attributesToRetrieve,
                  ...insightsParams
                }
              }
            ],
            searchClient,
            transformResponse: ({ results, hits }) => {
              const result = results[0];
              onResult?.(result);
              return (hits[0] ?? []).map((hit, index) => ({
                ...hit,
                __position: index + 1,
                __queryID: result?.queryID
              }));
            }
          });
        };
        const noopItem = {
          item: ({ html }) => html``
        };
        const sources = [
          {
            sourceId: "products",
            getItemUrl: ({ item }) => itemUrl(item),
            getItems: () => runQuery(
              config.indexes.products,
              5,
              productAttributesToRetrieve(PRODUCT_ATTRIBUTES_TO_RETRIEVE),
              (result) => setContext({
                productsNbHits: result?.nbHits,
                productsQueryID: result?.queryID,
                productsUserData: result?.userData
              })
            ),
            onSelect: ({ event, item, setIsOpen }) => {
              const target = event.target;
              if (target instanceof Element && target.closest(
                "[data-algolia-convert], [data-product-form], [data-algolia-click]"
              )) {
                setIsOpen(true);
                return;
              }
              navigateTo(itemUrl(item));
            },
            templates: noopItem
          },
          {
            sourceId: "sections",
            getItemUrl: ({ item }) => itemUrl(item),
            getItems: () => runQuery(
              config.indexes.sections,
              4,
              SIDEBAR_ATTRIBUTES_TO_RETRIEVE,
              (result) => setContext({ sectionsQueryID: result?.queryID })
            ),
            onSelect: ({ item }) => navigateTo(itemUrl(item)),
            templates: noopItem
          }
        ];
        if (config.indexes.suggestions) {
          sources.push({
            sourceId: "suggestions",
            getItemUrl: ({ item }) => searchUrlFor(String(item.title ?? item.query ?? "")),
            getItems: () => runQuery(
              config.indexes.suggestions,
              MAX_PREDICTIVE_QUERIES,
              QUERY_ATTRIBUTES_TO_RETRIEVE
            ),
            onSelect: ({ item }) => navigateTo(searchUrlFor(String(item.title ?? item.query ?? ""))),
            templates: noopItem
          });
        }
        return sources;
      };
    }
    // We paint results into our OWN persistent [data-algolia-panel] container
    // (not autocomplete-js's panel root) so the results survive the input losing
    // focus. autocomplete-js closes/empties ITS panel on blur; ours is untouched.
    renderPanel({ state }) {
      const panel = this.panel;
      const config = this.config;
      if (!panel || !config) return;
      const minLength = minimumQueryLength(state.query, config.shortQueries);
      if (!state.query || state.query.length < minLength) return;
      const products = itemsForSource(state, "products");
      const sections = itemsForSource(state, "sections");
      const suggestions = itemsForSource(state, "suggestions");
      this.showResultsState(products.length > 0);
      if (!products.length) {
        panel.innerHTML = `<div class="header-search__product-result is-no-result">
        <div>
          <span class="body-s-light">Sorry, we could not find any results matching your search.</span>
        </div>
      </div>`;
        return;
      }
      const productsQueryID = state.context.productsQueryID;
      const nbHits = state.context.productsNbHits ?? products.length;
      const markup = `
      <div class='algolia-results__main'>
        <div data-algolia-queries>${renderQueriesHtml(suggestions, state.query)}</div>
        <div data-algolia-products>${renderProductsHtml(config, products, nbHits, state.query, productsQueryID)}</div>
      </div>
      <div class='algolia-results__border'></div>
      <div class='algolia-results__sidebar'>
        <div data-algolia-explore>${renderExploreHtml(state.context.productsUserData)}</div>
        <div data-algolia-sections>${renderSectionsHtml(config, sections, state.context.sectionsQueryID)}</div>
      </div>`;
      panel.innerHTML = `<div data-algolia-results="">${markup}</div>`;
      void hydrateGiftProducts(panel);
    }
    // Hidden container that swallows autocomplete-js's own panel (its items use
    // empty templates anyway). Keeping its panel out of the visible layout lets us
    // fully control rendering via [data-algolia-panel] above.
    ensurePanelSink() {
      if (this.panelSink) return this.panelSink;
      const sink = document.createElement("div");
      sink.setAttribute("data-algolia-panel-sink", "");
      sink.style.cssText = "position:absolute;width:0;height:0;overflow:hidden;visibility:hidden;pointer-events:none";
      this.appendChild(sink);
      this.panelSink = sink;
      return sink;
    }
    async ensureAutocomplete() {
      if (this.autocompleteInstance || !this.config || !this.root) return;
      const config = this.config;
      const [{ autocomplete }, insightsClient] = await Promise.all([
        loadAutocompleteModule(),
        initAlgoliaInsights(config.appId, config.apiKey, config.indexes.products)
      ]);
      this.autocompleteInstance = autocomplete({
        container: this.root,
        panelContainer: this.ensurePanelSink(),
        detachedMediaQuery: "none",
        openOnFocus: true,
        autoFocus: true,
        placeholder: config.placeholder,
        // Reuse the theme's client so autocomplete's automatic view events carry
        // the same user token as every other surface; without consent the plugin
        // stays off instead of loading its own library and token.
        insights: insightsClient ? { insightsClient } : false,
        getSources: this.buildGetSources(config),
        onStateChange: ({ state }) => {
          renderRecentSearches(this.recentSearches, this.iconMarkup, state.query);
          this.hideClearButton();
          const minLength = minimumQueryLength(state.query, config.shortQueries);
          if (!state.query || state.query.length < minLength) {
            if (this.panel) this.panel.innerHTML = "";
            this.showEmptyState();
          }
        },
        onSubmit: ({ state }) => {
          writeRecentSearch(state.query);
          navigateTo(searchUrlFor(state.query));
        },
        render: (params) => this.renderPanel(params)
      });
      this.applyThemeToChrome();
      this.hideClearButton();
    }
    // Defensive belt-and-suspenders for the clear (X) button: CSS already hides it,
    // but autocomplete-js (re)injects it as soon as the input is non-empty, so we
    // also force it hidden inline on every state change. We only set an inline
    // style (never remove the node) so autocomplete-js can still set its innerHTML
    // on later renders — removing it throws "Cannot set properties of null".
    hideClearButton() {
      const scope = this.root ?? this;
      scope.querySelectorAll(".aa-ClearButton, .aa-InputWrapperSuffix").forEach((el) => el.style.setProperty("display", "none", "important"));
    }
    // Reuse the theme's existing field styling by tagging the library's own
    // elements with the classes the CSS already targets, and swap the default
    // submit icon for the brand search icon.
    applyThemeToChrome() {
      const root = this.root;
      if (!root) return;
      root.querySelector(".aa-Form")?.classList.add("header-search__form-search");
      const submit = root.querySelector(".aa-SubmitButton");
      if (submit) {
        submit.classList.add("header-search__icon-search");
        if (this.searchIconMarkup) submit.innerHTML = this.searchIconMarkup;
      }
      const input = root.querySelector("input");
      if (input) {
        input.setAttribute("type", "text");
        input.classList.add("header-search__input");
        input.setAttribute("aria-label", "Search");
        input.setAttribute("autocapitalize", "off");
        input.setAttribute("autocorrect", "off");
        input.setAttribute("spellcheck", "false");
        input.setAttribute("maxlength", "128");
      }
    }
  };
  if (!window.customElements.get("c-algolia-header-search")) {
    window.customElements.define("c-algolia-header-search", AlgoliaHeaderSearch);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-summary"]) return;
  try {
    
// ⚠ Auto-generated from src/sections/cart-summary/cart-summary.ts — do not edit directly.
// src/sections/cart-summary/cart-summary.ts
"use strict";
(() => {
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-panel"] && !Shopify.designMode) return;
  try {
    
  /**
   * Composant d'accordéon personnalisé
   * Gère l'expansion et la réduction d'une section de contenu
   * @extends HTMLElement
   */
  class TPanel extends HTMLElement {
    /**
     * @constructor
     * Initialise les éléments de l'accordéon
     */
    constructor() {
      super()
      this.initializeElements()
    }

    /**
     * Initialise les éléments DOM et les propriétés
     * @private
     */
    initializeElements() {
      this.toggleBtn = [...document.querySelectorAll('[data-panel-toggle]')]
      this.panel = this.querySelector('[data-panel]')
    }

    connectedCallback() {
      this.toggleBtn.forEach((btn) => {
        btn.addEventListener('click', this.handleToggle.bind(this))
      })
    }
    handleToggle() {
      this.panel.classList.toggle('is-open')
    }

    disconnectedCallback() {}
  }

  customElements.define('t-panel', TPanel)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["filter-collection"]) return;
  try {
    
// ⚠ Auto-generated from src/sections/filter-collection/filter-collection.ts — do not edit directly.
// src/sections/filter-collection/filter-collection.ts
"use strict";
(() => {
  // src/shared/utils/rendersection.ts
  async function renderSection(section, url = null, type = null) {
    try {
      let response;
      if (url) {
        if (type == null) {
          response = await fetch(
            `${window.location.pathname}?sections=${section.title}&${url.searchParams.toString()}`
          );
        } else if (type == "search") {
          response = await fetch(`${url}&sections=${section.title}`);
        }
      } else {
        response = await fetch(
          `${window.location.pathname}?sections=${section.title}`
        );
      }
      if (!response) return;
      if (response.ok) {
        const data = await response.json();
        section.selector.forEach((selector) => {
          const elements = [...document.querySelectorAll(selector)];
          let content;
          elements.forEach((element) => {
            if (element.dataset.id) {
              content = new DOMParser().parseFromString(data[section.title], "text/html").querySelector(`${selector}[data-id="${element.dataset.id}"]`);
            } else {
              content = new DOMParser().parseFromString(data[section.title], "text/html").querySelector(selector);
            }
            if (element && content) {
              element.innerHTML = content.innerHTML;
            }
          });
        });
      } else {
        console.error("Error:", response);
        window.location.reload();
      }
    } catch (error) {
      console.error("Error:", error);
      window.location.reload();
    }
  }
  async function renderAllSections(sections, url = null, type = null) {
    for (const section of sections) {
      await renderSection(section, url, type);
    }
  }

  // src/sections/filter-collection/filter-collection.ts
  var Tfilter = class extends HTMLElement {
    /**
     * @constructor
     * Initialise les propriétés du composant
     */
    constructor() {
      super();
      this.allNextPageProduct = [];
      this.btnSectionFilterDeslectAll = [];
      this.btnSectionFilterSelectAll = [];
      this.btnToggleFilter = [];
      this.closingTimeout = null;
      this.collection = null;
      this.dialog = null;
      this.filterActive = [];
      this.form = null;
      this.renderAllSections = renderAllSections;
      this.sectionsRender = [];
      this.initializeElements();
      this.initializeSections();
      this.closingTimeout = null;
      this.handleEscape = this.handleEscape.bind(this);
      this.eventChangeForm = this.eventChangeForm.bind(this);
    }
    /**
     * Initialise les éléments DOM du composant
     * @private
     */
    initializeElements() {
      this.dialog = this.querySelector("[data-filter-dialog]");
      this.form = this.querySelector("form#form-filter");
      this.btnToggleFilter = Array.from(
        this.querySelectorAll("[data-btn-toggle-filter]")
      );
      this.filterActive = Array.from(
        this.querySelectorAll("[data-filter-active]")
      );
      this.btnSectionFilterSelectAll = Array.from(
        this.querySelectorAll("[data-filter-select]")
      );
      this.btnSectionFilterDeslectAll = Array.from(
        this.querySelectorAll("[data-filter-remove]")
      );
      this.allNextPageProduct = [
        ...document.querySelectorAll(".collection-grid--next")
      ];
      this.renderAllSections = renderAllSections;
      this.collection = document.querySelector("t-collection");
    }
    /**
     * Initialise la configuration des sections
     * @private
     */
    initializeSections() {
      this.sectionsRender = [
        {
          title: "main-collection",
          selector: [
            "[data-btn-apply-filter]",
            "[data-inputs-filter]",
            "[data-filter-tag]",
            "[data-grid-collection]",
            "[data-legend-filter]",
            "[data-legend-sortby]",
            "[data-product-count]",
            "collection-grid--next",
            "[data-rerender-more]"
          ]
        },
        {
          title: "main-search",
          selector: [
            "[data-btn-apply-filter]",
            "[data-inputs-filter]",
            "[data-filter-tag]",
            "[data-grid-collection]",
            "[data-legend-filter]",
            "[data-legend-sortby]",
            "[data-product-count]",
            "collection-grid--next",
            "[data-rerender-more]"
          ]
        }
      ];
    }
    /**
     * Callback appelé lorsque l'élément est connecté au DOM
     */
    connectedCallback() {
      this.setupEventListeners();
    }
    /**
     * Configure les écouteurs d'événements initiaux
     * @private
     */
    setupEventListeners() {
      this.toggleFilter();
      this.backDropClose();
      this.escapeClose();
      this.form?.addEventListener("change", this.eventChangeForm);
      this.form?.addEventListener("submit", (event) => {
        event.preventDefault();
        this.toggleDialogState();
      });
      if (this.btnSectionFilterSelectAll.length > 0) {
        this.addEventSectionFilterSelectAll();
      }
      if (this.btnSectionFilterDeslectAll.length > 0) {
        this.addEventSectionFilterDeslectAll();
      }
      this.addEventDeselectFiltersLink();
    }
    /**
     * Adds event listener to deselect all filters link
     * @private
     */
    addEventDeselectFiltersLink() {
      const deselectLink = this.querySelector(
        "[data-deselect-filters-link]"
      );
      if (deselectLink !== null) {
        deselectLink.addEventListener("click", (event) => {
          event.preventDefault();
          const url = new URL(window.location.href);
          const qParam = url.searchParams.get("q");
          url.search = "";
          if (qParam) {
            url.searchParams.set("q", qParam);
          }
          history.pushState("", "", url.href);
          this.renderAllSections(this.sectionsRender, url);
          this.reSelectFilterActive();
          this.reselectBtnSectionFilterDeselectAll();
        });
      }
    }
    /**
     * Callback appelé lorsque l'élément est déconnecté du DOM
     */
    disconnectedCallback() {
      this.cleanup();
    }
    /**
     * Nettoie les écouteurs d'événements
     * @private
     */
    cleanup() {
      this.removeEventFilterActive();
      this.removeEventSectionFilterDeslectAll();
      this.form?.removeEventListener("change", this.eventChangeForm);
      window.removeEventListener("keydown", this.handleEscape);
    }
    /**
     * Gère la fermeture du dialogue via la touche Echap
     * @private
     */
    escapeClose() {
      window.addEventListener("keydown", this.handleEscape);
    }
    /**
     * Action à effectuer lors de l'appui sur Echap
     * @param {KeyboardEvent} event
     * @private
     */
    handleEscape(event) {
      if (event.key !== "Escape") return;
      if (!this.dialog?.open) return;
      event.preventDefault();
      this.toggleDialogState();
    }
    /**
     * Gère la fermeture du dialogue via le backdrop
     * @private
     */
    backDropClose() {
      this.dialog?.addEventListener("click", (event) => {
        if (!this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        const isInDialog = this.isClickInDialog(event, rect);
        if (!isInDialog) {
          this.toggleDialogState();
        }
      });
    }
    /**
     * Vérifie si un clic est à l'intérieur du dialogue
     * @param {MouseEvent} event - L'événement de clic
     * @param {DOMRect} rect - Les dimensions du dialogue
     * @returns {boolean}
     * @private
     */
    isClickInDialog(event, rect) {
      return rect.top <= event.clientY && event.clientY <= rect.top + rect.height && rect.left <= event.clientX && event.clientX <= rect.left + rect.width;
    }
    /**
     * Gère l'affichage/masquage du filtre
     * @private
     */
    toggleFilter() {
      this.btnToggleFilter?.forEach((btn) => {
        btn.addEventListener("click", () => this.toggleDialogState());
      });
    }
    /**
     * Bascule l'état du dialogue (ouvert/fermé)
     * @private
     */
    toggleDialogState() {
      if (!this.dialog) return;
      const dialog = this.dialog;
      if (this.closingTimeout) {
        clearTimeout(this.closingTimeout);
        this.closingTimeout = null;
      }
      if (dialog.open) {
        document.documentElement.classList.remove("is-overflow-hidden");
        this.closingTimeout = setTimeout(() => {
          dialog.close();
          this.closingTimeout = null;
        }, 900);
      } else {
        document.documentElement.classList.add("is-overflow-hidden");
        dialog.showModal();
      }
    }
    /**
     * Ajoute les écouteurs d'événements aux filtres actifs
     * @private
     */
    addEventFilterActive() {
      this.filterActive.forEach((filter) => {
        filter.addEventListener("click", () => this.removeFilterActive(filter));
      });
    }
    /**
     * Supprime les écouteurs d'événements des filtres actifs
     * @private
     */
    removeEventFilterActive() {
      this.filterActive.forEach((filter) => {
        filter.removeEventListener("click", () => this.removeFilterActive(filter));
      });
    }
    /**
     * Met à jour la sélection des filtres actifs
     * @private
     */
    reSelectFilterActive() {
      this.filterActive = Array.from(
        this.querySelectorAll("[data-filter-active]")
      );
      if (this.filterActive.length > 0) {
        this.removeEventFilterActive();
        this.addEventFilterActive();
      }
    }
    /**
     * Supprime un filtre actif
     * @param {HTMLElement} filter - L'élément filtre à supprimer
     * @private
     */
    async removeFilterActive(filter) {
      if (!filter.dataset.filterActive) return;
      history.pushState("", "", filter.dataset.filterActive);
      const url = new URL(window.location.href);
      await this.renderAllSections(this.sectionsRender, url);
      this.reSelectFilterActive();
      this.addEventDeselectFiltersLink();
    }
    /**
     * Gère les changements du formulaire
     * @private
     */
    async eventChangeForm() {
      if (!this.form) return;
      const searchParams = this.createSearchParams(this.form);
      const params = new URLSearchParams(window.location.search);
      let newUrl = null;
      if (params.has("q")) {
        newUrl = `${window.location.pathname}?q=${params.get("q")}&${searchParams}`;
      } else {
        newUrl = `${window.location.pathname}${searchParams ? "?" + searchParams : ""}`;
      }
      history.pushState({ searchParams }, "", newUrl);
      const url = new URL(window.location.href);
      await this.renderAllSections(this.sectionsRender, url);
      this.reRenderBtnmore();
      this.reSelectFilterActive();
      this.reselectBtnSectionFilterDeselectAll();
      this.addEventDeselectFiltersLink();
    }
    reRenderBtnmore() {
      if (!this.collection) return;
      this.collection.dataset.reRender = "true";
      this.allNextPageProduct.forEach((el) => el.classList.remove("is-active"));
    }
    /**
     * Crée les paramètres de recherche à partir du formulaire
     * @param {HTMLFormElement} form - Le formulaire à traiter
     * @returns {string}
     * @private
     */
    createSearchParams(form) {
      const params = new URLSearchParams();
      new FormData(form).forEach((value, key) => {
        if (typeof value === "string") {
          params.append(key, value);
        }
      });
      return params.toString();
    }
    /**
     * Met à jour les boutons de désélection des sections de filtres
     * @private
     */
    reselectBtnSectionFilterDeselectAll() {
      this.btnSectionFilterSelectAll = Array.from(
        this.querySelectorAll("[data-filter-select]")
      );
      this.btnSectionFilterDeslectAll = Array.from(
        this.querySelectorAll("[data-filter-remove]")
      );
      if (this.btnSectionFilterSelectAll.length > 0) {
        this.addEventSectionFilterSelectAll();
      }
      if (this.btnSectionFilterDeslectAll.length > 0) {
        this.removeEventSectionFilterDeslectAll();
        this.addEventSectionFilterDeslectAll();
      }
    }
    addEventSectionFilterSelectAll() {
      this.btnSectionFilterSelectAll.forEach((filter) => {
        filter.addEventListener("click", () => this.selectSectionFilter(filter));
      });
    }
    /**
     * Ajoute les écouteurs d'événements aux boutons de désélection des sections
     * @private
     */
    addEventSectionFilterDeslectAll() {
      this.btnSectionFilterDeslectAll.forEach((filter) => {
        filter.addEventListener("click", () => this.removeSectionFilter(filter));
      });
    }
    /**
     * Supprime les écouteurs d'événements des boutons de désélection des sections
     * @private
     */
    removeEventSectionFilterDeslectAll() {
      this.btnSectionFilterDeslectAll.forEach((filter) => {
        filter.removeEventListener(
          "click",
          () => this.removeSectionFilter(filter)
        );
      });
    }
    async selectSectionFilter(filter) {
      const url = new URL(window.location.href);
      const list = filter.closest("ul");
      if (!list) return;
      const checkboxes = Array.from(
        list.querySelectorAll(
          'input[type="checkbox"]:not([disabled])'
        )
      );
      checkboxes.forEach((checkbox) => {
        const paramName = checkbox.getAttribute("name");
        const paramValue = checkbox.getAttribute("value");
        if (!paramName || paramValue === null) return;
        url.searchParams.append(paramName, paramValue);
      });
      history.pushState("", "", url.href);
      await this.renderAllSections(this.sectionsRender, url);
      this.reSelectFilterActive();
      this.reselectBtnSectionFilterDeselectAll();
      this.addEventDeselectFiltersLink();
    }
    /**
     * Supprime un filtre de section
     * @param {HTMLElement} filter - L'élément filtre à supprimer
     * @private
     */
    async removeSectionFilter(filter) {
      const url = new URL(window.location.href);
      const filterName = filter.dataset.filterRemove;
      if (!filterName) return;
      url.searchParams.delete(filterName);
      history.pushState("", "", url.href);
      await this.renderAllSections(this.sectionsRender, url);
      this.reSelectFilterActive();
      this.reselectBtnSectionFilterDeselectAll();
      this.addEventDeselectFiltersLink();
    }
  };
  customElements.define("t-filter", Tfilter);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-search"] && !Shopify.designMode) return;
  try {
    
// ⚠ Auto-generated from src/sections/header-search/header-search.ts — do not edit directly.
// src/sections/header-search/header-search.ts
"use strict";
(() => {
  // src/shared/utils/rendersection.ts
  async function renderSection(section, url = null, type = null) {
    try {
      let response;
      if (url) {
        if (type == null) {
          response = await fetch(
            `${window.location.pathname}?sections=${section.title}&${url.searchParams.toString()}`
          );
        } else if (type == "search") {
          response = await fetch(`${url}&sections=${section.title}`);
        }
      } else {
        response = await fetch(
          `${window.location.pathname}?sections=${section.title}`
        );
      }
      if (!response) return;
      if (response.ok) {
        const data = await response.json();
        section.selector.forEach((selector) => {
          const elements = [...document.querySelectorAll(selector)];
          let content;
          elements.forEach((element) => {
            if (element.dataset.id) {
              content = new DOMParser().parseFromString(data[section.title], "text/html").querySelector(`${selector}[data-id="${element.dataset.id}"]`);
            } else {
              content = new DOMParser().parseFromString(data[section.title], "text/html").querySelector(selector);
            }
            if (element && content) {
              element.innerHTML = content.innerHTML;
            }
          });
        });
      } else {
        console.error("Error:", response);
        window.location.reload();
      }
    } catch (error) {
      console.error("Error:", error);
      window.location.reload();
    }
  }
  async function renderAllSections(sections, url = null, type = null) {
    for (const section of sections) {
      await renderSection(section, url, type);
    }
  }

  // src/sections/header-search/header-search.ts
  var TSearch = class extends HTMLElement {
    /**
     * @constructor
     * Initialise les propriétés du composant
     */
    constructor() {
      super();
      this.dialog = null;
      this.formPredictive = null;
      this.inputSearch = null;
      this.btnToggleSearch = [];
      this.sectionsRender = [];
      this.initializeElements();
      this.initializeSections();
      this.handleEscapeKey = this.handleEscapeKey.bind(this);
    }
    /**
     * Initialise les éléments DOM du composant
     * @private
     */
    initializeElements() {
      this.dialog = this.querySelector("[data-search-dialog]");
      this.formPredictive = this.querySelector(
        "[data-form-predictive-search]"
      );
      this.inputSearch = this.formPredictive?.querySelector(
        "input[type=search]"
      ) ?? null;
      this.btnToggleSearch = Array.from(
        document.querySelectorAll("[data-btn-toogle-search]")
      );
    }
    /**
     * Initialise la configuration des sections
     * @private
     */
    initializeSections() {
      this.sectionsRender = [
        {
          title: "header-search",
          selector: ["[data-predictive-result]"]
        }
      ];
    }
    /**
     * Callback appelé lorsque l'élément est connecté au DOM
     */
    connectedCallback() {
      this.setupEventListeners();
    }
    /**
     * Configure les écouteurs d'événements initiaux
     * @private
     */
    setupEventListeners() {
      this.toggleSearch();
      this.listenPredictiveSearch();
      window.addEventListener("keydown", this.handleEscapeKey);
    }
    /**
     * Callback appelé lorsque l'élément est déconnecté du DOM
     */
    disconnectedCallback() {
      this.cleanup();
    }
    handleEscapeKey(event) {
      if (event.key !== "Escape") return;
      if (!this.dialog?.open) return;
      event.preventDefault();
      this.toggleDialogState();
    }
    /**
     * Nettoie les écouteurs d'événements
     * @private
     */
    cleanup() {
      window.removeEventListener("keydown", this.handleEscapeKey);
    }
    listenPredictiveSearch() {
      this.formPredictive?.addEventListener(
        "input",
        this.fetchResultPredictive.bind(this)
      );
    }
    async fetchResultPredictive() {
      if (!this.formPredictive) return;
      const formData = new FormData(this.formPredictive);
      const input = formData.get("q");
      const searchQuery = typeof input === "string" ? input : "";
      if (searchQuery.length === 0) {
        await renderAllSections(this.sectionsRender);
        return;
      }
      const shopifyRoot = window.Shopify?.routes?.root ?? "/";
      const url = new URL(
        `${shopifyRoot}search/suggest?q=${encodeURIComponent(searchQuery)}&resources[type]=query,product&resources[limit]=10&resources[limit_scope]=each&resources[options][unavailable_products]=hide&[fields]=title,product_type,variants.title`,
        window.location.origin
      );
      await renderAllSections(this.sectionsRender, url, "search");
    }
    /**
     * Gère l'affichage/masquage du filtre
     * @private
     */
    toggleSearch() {
      this.btnToggleSearch.forEach((btn) => {
        btn.addEventListener("click", () => this.toggleDialogState());
      });
    }
    /**
     * Bascule l'état du dialogue (ouvert/fermé)
     * @private
     */
    toggleDialogState() {
      if (!this.dialog) return;
      if (this.dialog.open) {
        document.documentElement.classList.remove("is-overflow-hidden");
        this.dialog.close();
      } else {
        document.documentElement.classList.add("is-overflow-hidden");
        this.dialog.showModal();
      }
    }
  };
  customElements.define("t-search", TSearch);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
// ⚠ Auto-generated from src/sections/header/header.ts — do not edit directly.
// src/sections/header/header.ts
"use strict";
(() => {
  // src/sections/header/hover-header.ts
  var THoverHeader = class extends HTMLElement {
    constructor() {
      super();
      this.header = document.querySelector("t-menu");
      this.menuItems = Array.from(
        document.querySelectorAll(".menu__item")
      );
      this.subMenu = Array.from(
        document.querySelectorAll("[data-submenu]")
      );
      this.backdropMenu = document.querySelector(
        ".menu-dekstop-backdrop"
      );
    }
    connectedCallback() {
      this.header?.addEventListener("mouseleave", () => {
        this.handleOut();
      });
      this.backdropMenu?.addEventListener("mouseenter", () => {
        this.handleOut();
      });
      this.menuItems.forEach((el) => {
        el.addEventListener("mouseenter", () => {
          this.menuItems.forEach((ell) => {
            setTimeout(() => {
              ell.classList.remove("is-first");
            }, 900);
          });
        });
      });
    }
    handleOut() {
      this.menuItems.forEach((ell) => {
        ell.classList.add("is-first");
        this.subMenu.forEach((submenu) => {
          submenu.style.transition = "clip-path 0.9s cubic-bezier(0.48, -0.01, 0.34, 0.99), opacity 0.3s 0.6s cubic-bezier(0.48, -0.01, 0.34, 0.99)";
          setTimeout(() => {
            submenu.style.transition = "";
          }, 900);
        });
      });
    }
    disconnectedCallback() {
    }
  };
  customElements.define("t-hover-header", THoverHeader);

  // src/sections/header/menu.ts
  var TMenu = class extends HTMLElement {
    constructor() {
      super();
      /** Timeout pour le basculement de l'en-tête */
      this.timeoutHeaderTransition = null;
      /** Retraits différés en vol, indexés par classe : évite d'empiler un timer par événement de scroll */
      this.pendingRemovals = {};
      /** Référence stable du handler, indispensable pour pouvoir le retirer */
      this.boundHandleScroll = () => this.handleScroll();
      this.initializeElements();
    }
    /**
     * Initialise les éléments DOM et les propriétés
     * @private
     */
    initializeElements() {
      this.btnToggleMenu = Array.from(
        document.querySelectorAll("[data-btn-toogle-menu]")
      );
      this.btnToggleSubMenu = Array.from(
        this.querySelectorAll("[data-submenu-toggle]")
      );
      this.subMenus = Array.from(
        this.querySelectorAll("[data-submenu]")
      );
      this.currentSubMenu = null;
      this.header = document.querySelector("header");
      this.headerInside = document.querySelector(".header-inside");
      this.headerSection = this.header.querySelector(".header__section");
      this.lastScrollY = void 0;
      this.timeoutHeaderTransition = null;
    }
    /**
     * Configure les écouteurs d'événements lorsque l'élément est connecté au DOM
     */
    connectedCallback() {
      this.setupSubMenuListeners();
      this.setupMainMenuListeners();
      this.setupScrollListener();
      this.updateProductDescriptionThresholdState(
        window.scrollY > this.getHeaderThreshold()
      );
    }
    /**
     * Configure les écouteurs d'événements pour les sous-menus
     * @private
     */
    setupSubMenuListeners() {
      this.btnToggleSubMenu?.forEach((btn) => {
        btn.addEventListener("click", () => this.handleSubMenuToggle(btn));
      });
    }
    /**
     * Gère le basculement des sous-menus
     * @param {HTMLElement} btn - Le bouton de basculement cliqué
     * @private
     */
    handleSubMenuToggle(btn) {
      this.currentSubMenu = this.subMenus?.find(
        (subMenu) => subMenu.dataset.id === btn.dataset.id
      );
      this.currentSubMenu?.classList.toggle("is-open");
    }
    /**
     * Configure les écouteurs d'événements pour le menu principal
     * @private
     */
    setupMainMenuListeners() {
      this.btnToggleMenu?.forEach((btn) => {
        btn.addEventListener("click", () => this.handleMainMenuToggle(btn));
      });
    }
    /**
     * Gère le basculement du menu principal
     * @param {HTMLElement} btn - Le bouton de basculement cliqué
     * @private
     */
    handleMainMenuToggle(btn) {
      this.classList.toggle("is-open");
      btn.classList.toggle("is-open");
      const headerTranparent = this.header.querySelector(".header--transparent");
      const headerTranparentMobile = this.header.querySelector(
        ".header--transparent__mobile"
      );
      if (headerTranparent || headerTranparentMobile) {
        this.header.classList.add("header--transition");
      }
      if (this.timeoutHeaderTransition) {
        clearTimeout(this.timeoutHeaderTransition);
      }
      this.timeoutHeaderTransition = setTimeout(() => {
        this.header?.classList.remove("header--transition");
        this.timeoutHeaderTransition = null;
      }, 900);
      const banner = document.querySelector(".banner");
      const freeShippingBanner = document.querySelector("#FreeShippingBanner");
      const headerTop = this.header?.getBoundingClientRect().top || 0;
      const sizefreeShippingBanner = freeShippingBanner?.getBoundingClientRect().height || 0;
      const sizeBanner = banner?.getBoundingClientRect().height || 0;
      if (banner && headerTop > 0 || this.header?.classList.contains("menu-is-open")) {
        const total = sizeBanner + sizefreeShippingBanner;
        this.header?.style.setProperty("--move-to", `${total}px`);
        this.header?.classList.toggle("menu-is-open");
      }
      if (!this.classList.contains("is-open")) {
        this.currentSubMenu?.classList.remove("is-open");
        document.documentElement.classList.remove("is-overflow-hidden");
      } else {
        document.documentElement.classList.add("is-overflow-hidden");
      }
      this.currentSubMenu?.scrollTo(0, 0);
    }
    /**
     * Configure l'écouteur d'événements pour le défilement
     * @private
     */
    setupScrollListener() {
      window.addEventListener("scroll", this.boundHandleScroll, { passive: true });
    }
    /**
     * N'écrit dans le DOM que si l'état de la classe change réellement.
     * `classList.add/remove/toggle` réécrivent l'attribut `class` même à état
     * identique : appelés à chaque événement de scroll, ils généraient une mutation
     * du DOM par pixel parcouru (nœuds qui clignotent dans l'inspecteur).
     * @private
     */
    setClass(element, className, on) {
      if (!element || element.classList.contains(className) === on) return;
      element.classList.toggle(className, on);
    }
    /**
     * Programme un retrait différé unique : sans ce garde, chaque événement de
     * scroll créait son propre `setTimeout`, empilant des centaines de timers qui
     * continuaient à muter le DOM bien après l'arrêt du scroll.
     * @private
     */
    scheduleRemoval(element, className) {
      if (!element || this.pendingRemovals[className]) return;
      this.pendingRemovals[className] = setTimeout(() => {
        this.pendingRemovals[className] = null;
        this.setClass(element, className, false);
      }, 300);
    }
    /**
     * Retourne le seuil à partir duquel le header change pendant le scroll.
     * Sur les pages produit desktop, il correspond au bas de la description
     * lorsque celui-ci atteint le bas du viewport.
     * @returns {number}
     * @private
     */
    getHeaderThreshold() {
      const defaultThreshold = this.headerInside.offsetHeight * 2;
      const productDescription = this.getDesktopProductDescription();
      if (!productDescription) {
        return defaultThreshold;
      }
      const descriptionBottom = window.scrollY + productDescription.getBoundingClientRect().bottom;
      return Math.max(0, descriptionBottom - window.innerHeight);
    }
    /**
     * Retourne la description produit lorsque le seuil PDP desktop est actif.
     * @returns {Element|null}
     * @private
     */
    getDesktopProductDescription() {
      const isDesktop = window.matchMedia("(min-width: 1024px)").matches;
      if (!isDesktop) {
        return null;
      }
      return document.querySelector(".body--product .main-product__description");
    }
    /**
     * Met à jour la position spécifique du header sur le PDP desktop.
     * @param {boolean} hasPassedThreshold
     * @private
     */
    updateProductDescriptionThresholdState(hasPassedThreshold) {
      const usesProductDescriptionThreshold = Boolean(
        this.getDesktopProductDescription()
      );
      this.setClass(
        this.header,
        "has-product-description-threshold",
        usesProductDescriptionThreshold
      );
      this.setClass(
        this.header,
        "is-product-description-passed",
        usesProductDescriptionThreshold && hasPassedThreshold
      );
    }
    /**
     * Gère le comportement du menu lors du défilement
     * @private
     */
    handleScroll() {
      if (this.lastScrollY === void 0) {
        this.lastScrollY = window.scrollY + this.headerInside.offsetHeight * 2;
      }
      const headerThreshold = this.getHeaderThreshold();
      const scrollDownThreshold = this.headerInside.offsetHeight * 2;
      const isScrollingDown = window.scrollY > this.lastScrollY;
      const hasPassedThreshold = window.scrollY > headerThreshold;
      const hasPassedScrollDownThreshold = window.scrollY > scrollDownThreshold;
      const stickyDosoon = document.querySelector(".sticky-doson .sticky");
      const stickySize = stickyDosoon?.getBoundingClientRect();
      this.updateProductDescriptionThresholdState(hasPassedThreshold);
      if (isScrollingDown && hasPassedScrollDownThreshold) {
        this.setClass(this.header, "is-scroll-down", true);
      } else if (!isScrollingDown) {
        this.setClass(this.header, "is-scroll-down", false);
      }
      if (!isScrollingDown && hasPassedThreshold) {
        if (this.headerSection.classList.contains("header--grid")) {
          this.setClass(this.headerSection, "header--transparent", false);
        }
        if (this.headerSection.classList.contains("header--grid-mobile")) {
          this.setClass(this.headerSection, "header--transparent__mobile", false);
        }
        if (stickyDosoon && stickySize?.top == headerThreshold + 2) {
          this.setClass(stickyDosoon, "is-show", true);
        }
        if (stickyDosoon && stickySize && stickySize.top > headerThreshold + 2) {
          this.setClass(stickyDosoon, "is-show", false);
        }
      } else if (isScrollingDown && hasPassedThreshold) {
        if (this.headerSection.classList.contains("header--grid")) {
          this.scheduleRemoval(this.headerSection, "header--transparent");
        }
        if (this.headerSection.classList.contains("header--grid-mobile")) {
          this.scheduleRemoval(this.headerSection, "header--transparent__mobile");
        }
        if (stickyDosoon && stickySize?.top == 0) {
          this.setClass(stickyDosoon, "is-show", true);
        }
      } else {
        if (this.headerSection.classList.contains("header--grid")) {
          this.setClass(this.headerSection, "header--transparent", true);
        }
        if (this.headerSection.classList.contains("header--grid-mobile")) {
          this.setClass(this.headerSection, "header--transparent__mobile", true);
        }
        this.setClass(stickyDosoon, "is-show", false);
      }
      this.lastScrollY = window.scrollY;
    }
    /**
     * Nettoie les écouteurs d'événements lors de la déconnexion
     */
    disconnectedCallback() {
      window.removeEventListener("scroll", this.boundHandleScroll);
      Object.values(this.pendingRemovals).forEach((timer) => {
        if (timer) clearTimeout(timer);
      });
      this.pendingRemovals = {};
    }
  };
  customElements.define("t-menu", TMenu);
  var mobileSearchBar = class extends HTMLElement {
    constructor() {
      super();
      // NB : ne jamais nommer ce champ `onclick` — la cible esbuild (es2020) abaisse
      // les class fields en assignations constructeur, ce qui déclencherait le setter
      // natif `onclick` en plus du addEventListener → double appel → ouverture/fermeture
      // immédiate du dialog de recherche.
      this.handleClick = () => {
        this.searchIcon?.click();
      };
    }
    connectedCallback() {
      this.addEventListener("click", this.handleClick);
    }
    get searchIcon() {
      return this.closest(".shopify-section")?.querySelector(
        "[data-btn-toogle-search]"
      ) ?? null;
    }
  };
  if (!window.customElements.get("mobile-search-bar")) {
    window.customElements.define("mobile-search-bar", mobileSearchBar);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-collection"]) return;
  try {
    
// ⚠ Auto-generated from src/sections/hero-collection/hero-collection.ts — do not edit directly.
// src/sections/hero-collection/hero-collection.ts
"use strict";
(() => {
  // src/sections/hero-collection/hero-collection.ts
  var TTuncat = class extends HTMLElement {
    constructor() {
      super();
      this.maxLines = 2;
      this.content = null;
      this.label = null;
      this.checkbox = null;
      this.originalHTML = "";
      this.plainChars = [];
      this.seeMoreText = "";
      this.seeLessText = "";
      this.truncatedView = null;
      this.fullView = null;
      this.resizeTimeout = null;
      this._boundDebouncedRender = null;
    }
    connectedCallback() {
      this.initialize();
      this.setupEventListeners();
    }
    initialize() {
      this.checkbox = this.querySelector('input[type="checkbox"]');
      this.label = this.querySelector("label");
      if (this.label) {
        const seeMoreSpan = this.label.querySelector(
          ".hero-collection_description_see-more"
        );
        const seeLessSpan = this.label.querySelector(
          ".hero-collection_description_see-less"
        );
        if (seeMoreSpan) this.seeMoreText = seeMoreSpan.textContent?.trim() ?? "";
        if (seeLessSpan) this.seeLessText = seeLessSpan.textContent?.trim() ?? "";
        this.label.style.display = "none";
      }
      this.setupContent();
      this.render();
    }
    /**
     * Localise (ou crée) le paragraphe de contenu et mémorise le HTML d'origine
     * ainsi que sa version texte brut découpée en graphèmes (surrogate-safe).
     */
    setupContent() {
      this.content = this.querySelector("p");
      if (!this.content) {
        const contentNodes = [];
        Array.from(this.childNodes).forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const el = node;
            const tag = el.tagName.toLowerCase();
            if (tag === "input" || tag === "label") return;
          }
          if (node.nodeType === Node.TEXT_NODE && node.textContent?.trim() || node.nodeType === Node.ELEMENT_NODE) {
            contentNodes.push(node);
          }
        });
        if (contentNodes.length > 0) {
          this.content = document.createElement("p");
          contentNodes.forEach((node) => {
            this.content.appendChild(node.cloneNode(true));
            if (node.parentNode === this) this.removeChild(node);
          });
          if (this.checkbox) {
            this.insertBefore(this.content, this.checkbox.nextSibling);
          } else {
            this.insertBefore(this.content, this.firstChild);
          }
        }
      }
      if (this.content) {
        this.originalHTML = this.content.innerHTML;
        const plain = (this.content.textContent ?? "").replace(/\s+/g, " ").trim();
        this.plainChars = Array.from(plain);
      }
      this.style.display = "block";
      this.style.textAlign = "center";
      if (this.content) {
        this.content.style.maxWidth = "653px";
        this.content.style.margin = "0 auto";
      }
    }
    setupEventListeners() {
      if (this.checkbox) {
        this.checkbox.addEventListener("change", this.handleToggle.bind(this));
      }
      this._boundDebouncedRender = this.debouncedRender.bind(this);
      window.addEventListener("resize", this._boundDebouncedRender);
    }
    debouncedRender() {
      if (this.resizeTimeout) clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => this.render(), 200);
    }
    /**
     * Crée un clone hors écran calé sur la largeur et la typographie réelles du
     * contenu, pour mesurer la hauteur rendue d'un texte candidat.
     */
    createMeasurer(cs) {
      const width = this.content.clientWidth || 653;
      const measurer = document.createElement("div");
      measurer.style.cssText = [
        "position:absolute",
        "left:-99999px",
        "top:0",
        "visibility:hidden",
        "height:auto",
        "overflow:visible",
        "white-space:normal",
        `width:${width}px`,
        `font-size:${cs.fontSize}`,
        `font-family:${cs.fontFamily}`,
        `font-weight:${cs.fontWeight}`,
        `font-style:${cs.fontStyle}`,
        `letter-spacing:${cs.letterSpacing}`,
        `line-height:${cs.lineHeight}`,
        `text-align:${cs.textAlign}`,
        `word-break:${cs.wordBreak}`,
        `overflow-wrap:${cs.overflowWrap}`
      ].join(";");
      return measurer;
    }
    /**
     * Reconstruit l'affichage : mesure le débordement et, le cas échéant, calcule
     * par dichotomie le plus long texte qui tient en `maxLines` lignes une fois le
     * bouton « voir plus » inclus.
     */
    render() {
      if (!this.content) return;
      this.truncatedView = null;
      this.fullView = null;
      this.content.innerHTML = this.originalHTML;
      this.content.style.display = "block";
      this.content.style.webkitLineClamp = "unset";
      this.content.style.overflow = "visible";
      const cs = window.getComputedStyle(this.content);
      const lineHeight = parseFloat(cs.lineHeight) || parseFloat(cs.fontSize) * 1.4;
      const maxHeight = lineHeight * this.maxLines + 1;
      const measurer = this.createMeasurer(cs);
      document.body.appendChild(measurer);
      measurer.textContent = this.plainChars.join("");
      const overflows = measurer.scrollHeight > maxHeight;
      if (!overflows) {
        document.body.removeChild(measurer);
        this.content.innerHTML = this.originalHTML;
        this.classList.add("is-ready");
        return;
      }
      const suffix = "\u2026 " + this.seeMoreText;
      const fits = (count) => {
        measurer.textContent = this.plainChars.slice(0, count).join("") + suffix;
        return measurer.scrollHeight <= maxHeight;
      };
      let lo = 0;
      let hi = this.plainChars.length;
      let best = 0;
      while (lo <= hi) {
        const mid = lo + hi >> 1;
        if (fits(mid)) {
          best = mid;
          lo = mid + 1;
        } else {
          hi = mid - 1;
        }
      }
      document.body.removeChild(measurer);
      let truncatedText = this.plainChars.slice(0, best).join("");
      truncatedText = truncatedText.replace(/[\s.,;:]+$/u, "");
      this.buildViews(truncatedText);
      this.applyState(!!(this.checkbox && this.checkbox.checked));
      this.classList.add("is-ready");
    }
    buildViews(truncatedText) {
      if (!this.content) return;
      const truncatedContainer = document.createElement("span");
      truncatedContainer.className = "truncated-view";
      truncatedContainer.appendChild(
        document.createTextNode(truncatedText + "\u2026 ")
      );
      const seeMoreBtn = document.createElement("a");
      seeMoreBtn.className = "hero-collection_description_see-more inline-toggle-link";
      seeMoreBtn.textContent = this.seeMoreText;
      seeMoreBtn.setAttribute("role", "button");
      seeMoreBtn.style.cssText = "cursor:pointer;text-decoration:underline;color:var(--color-gray);display:inline;white-space:nowrap;";
      seeMoreBtn.addEventListener("click", (e) => {
        e.preventDefault();
        this.setExpanded(true);
      });
      truncatedContainer.appendChild(seeMoreBtn);
      const fullContainer = document.createElement("div");
      fullContainer.className = "full-view";
      fullContainer.innerHTML = this.originalHTML;
      const seeLessBtn = document.createElement("a");
      seeLessBtn.className = "hero-collection_description_see-less";
      seeLessBtn.textContent = this.seeLessText;
      seeLessBtn.setAttribute("role", "button");
      seeLessBtn.style.cssText = "display:block;margin-top:8px;cursor:pointer;text-decoration:underline;color:var(--color-gray);";
      seeLessBtn.addEventListener("click", (e) => {
        e.preventDefault();
        this.setExpanded(false);
      });
      fullContainer.appendChild(seeLessBtn);
      this.content.innerHTML = "";
      this.content.appendChild(truncatedContainer);
      this.content.appendChild(fullContainer);
      this.truncatedView = truncatedContainer;
      this.fullView = fullContainer;
    }
    setExpanded(expanded) {
      if (this.checkbox) {
        this.checkbox.checked = expanded;
        this.checkbox.dispatchEvent(new Event("change"));
      } else {
        this.applyState(expanded);
      }
    }
    handleToggle() {
      if (!this.checkbox) return;
      this.applyState(this.checkbox.checked);
    }
    applyState(isExpanded) {
      if (!this.truncatedView || !this.fullView) return;
      if (isExpanded) {
        this.truncatedView.style.display = "none";
        this.fullView.style.display = "block";
        this.classList.add("is-expanded");
      } else {
        this.truncatedView.style.display = "inline";
        this.fullView.style.display = "none";
        this.classList.remove("is-expanded");
      }
    }
    disconnectedCallback() {
      if (this._boundDebouncedRender) {
        window.removeEventListener("resize", this._boundDebouncedRender);
      }
    }
  };
  if (!customElements.get("t-tuncat")) {
    customElements.define("t-tuncat", TTuncat);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
// ⚠ Auto-generated from src/sections/main-cart/main-cart.ts — do not edit directly.
// src/sections/main-cart/main-cart.ts
"use strict";
(() => {
  // src/shared/utils/rendersection.ts
  async function renderSection(section, url = null, type = null) {
    try {
      let response;
      if (url) {
        if (type == null) {
          response = await fetch(
            `${window.location.pathname}?sections=${section.title}&${url.searchParams.toString()}`
          );
        } else if (type == "search") {
          response = await fetch(`${url}&sections=${section.title}`);
        }
      } else {
        response = await fetch(
          `${window.location.pathname}?sections=${section.title}`
        );
      }
      if (!response) return;
      if (response.ok) {
        const data = await response.json();
        section.selector.forEach((selector) => {
          const elements = [...document.querySelectorAll(selector)];
          let content;
          elements.forEach((element) => {
            if (element.dataset.id) {
              content = new DOMParser().parseFromString(data[section.title], "text/html").querySelector(`${selector}[data-id="${element.dataset.id}"]`);
            } else {
              content = new DOMParser().parseFromString(data[section.title], "text/html").querySelector(selector);
            }
            if (element && content) {
              element.innerHTML = content.innerHTML;
            }
          });
        });
      } else {
        console.error("Error:", response);
        window.location.reload();
      }
    } catch (error) {
      console.error("Error:", error);
      window.location.reload();
    }
  }
  async function renderAllSections(sections, url = null, type = null) {
    for (const section of sections) {
      await renderSection(section, url, type);
    }
  }

  // src/sections/main-cart/cart-discount.ts
  var CartDiscount = class extends HTMLElement {
    constructor() {
      super();
      this.container = this.querySelector("[data-cart-discount]");
      this.button = this.container?.querySelector(".button") ?? null;
      this.input = this.container?.querySelector("[data-cart-discount-input]") ?? null;
      this.errorElement = this.container?.querySelector("[data-discount-error]") ?? null;
      const shopifyWrapper = this.closest('[id^="shopify-section-"]');
      const sectionInstanceId = shopifyWrapper?.id?.replace(
        "shopify-section-",
        ""
      );
      this.sectionsRender = [
        {
          title: sectionInstanceId ?? "",
          selector: ["[data-cart-total]", "[data-cart-items]"]
        }
      ];
    }
    connectedCallback() {
      this.button?.addEventListener("click", () => this.handleButtonClick());
    }
    disconnectedCallback() {
      this.removeEvents();
    }
    removeEvents() {
      this.button?.removeEventListener("click", this.handleButtonClick);
    }
    handleButtonClick() {
      if (this.button?.hasAttribute("data-cart-discount-apply")) {
        this.applyDiscount();
      } else if (this.button?.hasAttribute("data-cart-discount-remove")) {
        this.removeDiscount();
      }
    }
    async applyDiscount() {
      this.errorElement?.classList.add("hide");
      if (!this.button || !this.input) return;
      this.button.disabled = true;
      try {
        const code = this.input.value.trim();
        if (!code) return;
        const response = await fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            discount: code
          })
        });
        if (!response.ok) {
          throw new Error(`Apply discount failed: ${response.status}`);
        }
        const data = await response.json();
        const discountCodeApplication = data.discount_codes[0].applicable;
        if (discountCodeApplication == false) {
          this.showError();
        } else {
          await this.updateCartSections();
        }
      } catch (error) {
        console.error("[CartDiscount] applyDiscount error:", error);
        this.showError();
      } finally {
        this.button.disabled = false;
      }
    }
    async removeDiscount() {
      if (!this.button) return;
      this.button.disabled = true;
      try {
        const response = await fetch(
          `${window.Shopify?.routes?.root || "/"}cart/update.js`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              discount: ""
            })
          }
        );
        if (!response.ok) {
          throw new Error(`Remove discount failed: ${response.status}`);
        }
        await this.updateCartSections();
      } catch (error) {
        console.error("[CartDiscount] removeDiscount error:", error);
        this.showError();
      } finally {
        this.button.disabled = false;
      }
    }
    async updateCartSections() {
      if (renderAllSections) {
        history.pushState("", "", `${window.location.href}`);
        const url = new URL(window.location.href);
        await renderAllSections(this.sectionsRender, url);
      } else {
        window.location.reload();
      }
    }
    showError() {
      this.errorElement?.classList.remove("hide");
    }
  };
  customElements.define("cart-discount", CartDiscount);

  // src/shared/cart-limit-error/cart-limit-error.ts
  var ERROR_MESSAGE_SELECTOR = "[data-cart-limit-error-message]";
  var ERROR_TEXT_SELECTOR = "[data-cart-limit-error-text]";
  var OPEN_ENGRAVING_PANEL_SELECTOR = "c-engraving-panel.is-open";
  var SEARCH_DIALOG_SELECTOR = "dialog[data-search-dialog]";
  var QUANTITY_LIMIT_PATTERNS = [
    /can'?t add more/i,
    /maximum allowed quantity/i,
    /maximum quantity/i,
    /quantity.*exceeded/i,
    /only add \d+/i
  ];
  function getErrorMessageEl() {
    return document.querySelector(ERROR_MESSAGE_SELECTOR);
  }
  function getDefaultMessage() {
    return window.cartStrings?.addToCartLimitError ?? "The maximum allowed quantity for this product has been exceeded.";
  }
  function isCartQuantityLimitError(status, description) {
    if (status !== 422) return false;
    const normalized = description.trim();
    if (normalized.length === 0) return true;
    return QUANTITY_LIMIT_PATTERNS.some((pattern) => pattern.test(normalized));
  }
  function closeOpenEngravingPanels() {
    document.querySelectorAll(OPEN_ENGRAVING_PANEL_SELECTOR).forEach((panel) => {
      ;
      panel.close();
    });
  }
  function closeHeaderSearchIfOpen() {
    const openDialogs = document.querySelectorAll(
      `${SEARCH_DIALOG_SELECTOR}[open]`
    );
    if (openDialogs.length === 0) return;
    document.documentElement.classList.remove("is-overflow-hidden");
    openDialogs.forEach((dialog) => {
      dialog.close();
    });
  }
  function showCartLimitError(message) {
    closeHeaderSearchIfOpen();
    const errorMessage = getErrorMessageEl();
    if (!errorMessage) return;
    const textEl = errorMessage.querySelector(ERROR_TEXT_SELECTOR);
    if (textEl) {
      textEl.textContent = message ?? getDefaultMessage();
    }
    if (errorMessage.classList.contains("hidden")) {
      errorMessage.classList.remove("hidden");
    }
    closeOpenEngravingPanels();
    window.scrollTo(0, 0);
  }
  function hideCartLimitError() {
    const errorMessage = getErrorMessageEl();
    if (!errorMessage || errorMessage.classList.contains("hidden")) return;
    errorMessage.classList.add("hidden");
  }

  // src/sections/main-cart/cart-item-quantity.ts
  var CartItemQuantity = class extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input[type="number"]');
      this.minusButton = this.querySelector('[data-action="minus"]');
      this.plusButton = this.querySelector('[data-action="plus"]');
      this.allSample = [
        ...document.querySelectorAll("[data-parent-id]")
      ];
      this.varaintId = this.dataset.variantId;
      this.urlChange = this.dataset.url;
      this.lineIndex = this.getAttribute("data-line");
      this.originalQuantity = parseInt(
        this.getAttribute("data-original-quantity") || this.input.value,
        10
      );
      this.maxQuantity = parseInt(this.input.getAttribute("max") || "0", 10);
      this.init();
    }
    init() {
      this.bindEvents();
      this.setOriginalQuantity();
      this.updateButtonStates();
    }
    bindEvents() {
      if (this.minusButton) {
        this.minusButton.addEventListener("click", this.handleMinus.bind(this));
      }
      if (this.plusButton) {
        this.plusButton.addEventListener("click", this.handlePlus.bind(this));
      }
      this.input.addEventListener("blur", this.handleBlur.bind(this));
      this.input.addEventListener("keypress", this.handleKeypress.bind(this));
      this.input.addEventListener("keydown", this.handleKeydown.bind(this));
      this.input.addEventListener("input", this.handleInput.bind(this));
    }
    syncErrorVisibility(quantity) {
      if (this.maxQuantity > 0 && quantity > this.maxQuantity) {
        showCartLimitError();
        return;
      }
      hideCartLimitError();
    }
    handleMinus() {
      const currentValue = parseInt(this.input.value, 10);
      if (currentValue > 1) {
        this.input.value = (currentValue - 1).toString();
        this.updateQuantity(currentValue - 1);
        this.updateButtonStates();
        this.syncErrorVisibility(currentValue - 1);
      }
    }
    handlePlus() {
      const currentValue = parseInt(this.input.value, 10);
      if (this.maxQuantity > 0 && currentValue >= this.maxQuantity) {
        showCartLimitError();
        return;
      }
      if (currentValue < this.maxQuantity || this.maxQuantity <= 0) {
        this.input.value = (currentValue + 1).toString();
        this.updateQuantity(currentValue + 1);
        this.updateButtonStates();
        this.syncErrorVisibility(currentValue + 1);
      }
    }
    handleBlur() {
      const cleanStr = this.input.value.replace(/[^0-9]/g, "");
      let newQuantity = parseInt(cleanStr, 10);
      if (Number.isNaN(newQuantity) || newQuantity < 1) {
        this.input.value = "1";
        newQuantity = 1;
      } else if (this.maxQuantity > 0 && newQuantity > this.maxQuantity) {
        this.input.value = this.maxQuantity.toString();
        newQuantity = this.maxQuantity;
        showCartLimitError();
      } else {
        hideCartLimitError();
      }
      if (newQuantity !== this.originalQuantity) {
        this.updateQuantity(newQuantity);
      }
      this.updateButtonStates();
    }
    handleKeypress(e) {
      e.preventDefault();
      if (e.key === "Enter") {
        this.input.blur();
      }
    }
    handleKeydown(e) {
      if ([8, 9, 27, 13, 37, 38, 39, 40].indexOf(e.keyCode) !== -1) {
        return;
      }
      if (e.keyCode >= 48 && e.keyCode <= 57) {
        return;
      }
      if (e.keyCode >= 96 && e.keyCode <= 105) {
        return;
      }
      e.preventDefault();
    }
    handleInput() {
      const cleanValue = this.input.value.replace(/[^0-9]/g, "");
      if (cleanValue !== this.input.value) {
        this.input.value = cleanValue;
      }
      const currentValue = parseInt(cleanValue, 10);
      this.input.classList.remove("error");
      if (this.maxQuantity > 0 && currentValue > this.maxQuantity) {
        this.input.value = this.maxQuantity.toString();
        this.input.classList.add("error");
        showCartLimitError();
      } else if (currentValue < 1) {
        this.input.classList.add("error");
      } else {
        hideCartLimitError();
      }
      this.updateButtonStates();
    }
    updateButtonStates() {
      const currentValue = parseInt(this.input.value, 10);
      if (this.minusButton) {
        this.minusButton.classList.toggle(
          "cart__item-quantity-button--disabled",
          currentValue == 0
        );
      }
      if (this.plusButton) {
        this.plusButton.classList.toggle(
          "cart__item-quantity-button--disabled",
          this.maxQuantity > 0 && currentValue >= this.maxQuantity
        );
      }
    }
    updateQuantity(quantity) {
      const formData = new FormData();
      const sampleProduct = this.allSample.find(
        (sample) => sample.dataset.parentId == this.varaintId
      );
      if (sampleProduct != void 0) {
        formData.append(
          `updates[${sampleProduct.dataset.childId}]`,
          quantity.toString()
        );
      }
      formData.append(`updates[${this.varaintId}]`, quantity.toString());
      fetch((window.Shopify?.routes?.root || "/") + "cart/update.js", {
        method: "POST",
        body: formData
      }).then(async (response) => {
        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          const rawMessage = errorData.description || errorData.message || `Erreur ${response.status}`;
          if (isCartQuantityLimitError(response.status, rawMessage)) {
            showCartLimitError();
          } else {
            showCartLimitError(rawMessage);
          }
          this.reset();
          return;
        }
        hideCartLimitError();
        window.location.reload();
      }).catch(() => {
        this.reset();
      });
    }
    setOriginalQuantity() {
      this.originalQuantity = parseInt(this.input.value, 10);
      this.setAttribute("data-original-quantity", this.input.value);
    }
    updateOriginalQuantity() {
      this.originalQuantity = parseInt(this.input.value, 10);
      this.setOriginalQuantity();
    }
    reset() {
      this.input.value = this.originalQuantity.toString();
      this.input.classList.remove("error");
      this.updateButtonStates();
    }
    get quantity() {
      return parseInt(this.input.value, 10);
    }
    set quantity(value) {
      this.input.value = value.toString();
      this.updateButtonStates();
    }
  };
  customElements.define("cart-item-quantity", CartItemQuantity);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
// ⚠ Auto-generated from src/sections/main-collection/main-collection.ts — do not edit directly.
// src/sections/main-collection/main-collection.ts
"use strict";
(() => {
  // src/sections/main-collection/main-collection.ts
  var TCollection = class extends HTMLElement {
    /**
     * @constructor
     * Initialise les éléments et les événements
     */
    constructor() {
      super();
      this.btnMore = null;
      this.currentPage = 1;
      this.isLoading = false;
      this.maxPages = 1;
      this.pageInload = null;
      this.loadMoreProducts = this.loadMoreProducts.bind(this);
      this.checkUrlOnLoad = this.checkUrlOnLoad.bind(this);
      this.initElements();
      this.bindEvents();
      this.checkUrlOnLoad();
    }
    static get observedAttributes() {
      return ["data-re-render"];
    }
    attributeChangedCallback(name, oldValue, newValue) {
      if (oldValue === newValue) return;
      if (name == "data-re-render" && newValue === "true") {
        this.initElements();
        this.bindEvents();
      }
    }
    /**
     * Initialise les éléments DOM nécessaires
     * @private
     */
    initElements() {
      this.btnMore = this.querySelector("[data-more]");
      this.maxPages = parseInt(this.btnMore?.dataset.maxPages || "1", 10);
      this.currentPage = 1;
      this.isLoading = false;
      this.pageInload = null;
    }
    /**
     * Associe les événements aux éléments
     * @private
     */
    bindEvents() {
      if (this.btnMore) {
        this.btnMore.removeEventListener("click", this.loadMoreProducts);
        this.btnMore.addEventListener("click", this.loadMoreProducts);
      }
      window.removeEventListener("popstate", this.checkUrlOnLoad);
      window.addEventListener("popstate", this.checkUrlOnLoad);
    }
    /**
     * Vérifie l'URL lors du chargement de la page pour charger la bonne page de produits
     * @private
     */
    checkUrlOnLoad() {
      const params = new URLSearchParams(window.location.search);
      const pageParam = params.get("page");
      const pageInload = pageParam ? parseInt(pageParam, 10) : null;
      if (pageParam) {
        const pageNumber = parseInt(pageParam, 10);
        if (pageNumber > 1 && pageNumber <= this.maxPages) {
          this.currentPage = 1;
          this.loadPagesSequentially(pageNumber, pageInload);
        }
      }
    }
    /**
     * Charge séquentiellement les pages de produits jusqu'à la page cible
     * @param {number} targetPage - La page cible à atteindre
     * @private
     */
    async loadPagesSequentially(targetPage, pageInload) {
      this.isLoading = true;
      for (let i = 1; i <= targetPage; i++) {
        await this.fetchPage(i, pageInload);
        this.currentPage = i;
      }
      this.isLoading = false;
      this.updateMoreButton();
    }
    /**
     * Charge plus de produits au clic sur le bouton "more"
     * @private
     */
    async loadMoreProducts() {
      if (this.isLoading) return;
      if (!this.btnMore) return;
      const nextPageUrl = this.btnMore.dataset.next;
      if (!nextPageUrl) return;
      const pageNumber = new URLSearchParams(nextPageUrl.split("?")[1]).get(
        "page"
      );
      if (!pageNumber) return;
      this.isLoading = true;
      history.pushState("", "", nextPageUrl);
      await this.fetchPage(pageNumber);
      this.currentPage = parseInt(pageNumber, 10);
      this.isLoading = false;
      this.updateMoreButton();
    }
    /**
     * Récupère les produits d'une page spécifique
     * @param {number|string} pageNumber - Le numéro de la page à récupérer
     * @private
     */
    async fetchPage(pageNumber, pageInload = null) {
      try {
        if (!this.btnMore) return;
        const nextPageUrl = this.btnMore.dataset.next;
        if (!nextPageUrl) return;
        const url = `${nextPageUrl}&sections=main-collection`;
        const response = await fetch(url);
        if (!response.ok) {
          console.error(
            "Erreur lors du chargement de la page:",
            response.statusText
          );
          return;
        }
        const data = await response.json();
        let targetContainer;
        if (pageInload == pageNumber) {
          targetContainer = document.querySelector(`[data-grid-collection]`);
        } else {
          targetContainer = document.querySelector(`#pages${pageNumber}`);
          targetContainer?.classList.add("is-active");
        }
        if (targetContainer && data["main-collection"]) {
          const parsedContent = new DOMParser().parseFromString(data["main-collection"], "text/html").querySelector("[data-grid-collection]");
          if (parsedContent) {
            targetContainer.innerHTML = parsedContent.innerHTML;
          }
        }
        const btnMoreContainer = document.querySelector("[data-rerender-more]");
        if (btnMoreContainer && data["main-collection"]) {
          const newBtnContent = new DOMParser().parseFromString(data["main-collection"], "text/html").querySelector("[data-rerender-more]");
          if (newBtnContent) {
            btnMoreContainer.innerHTML = newBtnContent.innerHTML;
            this.initElements();
            this.bindEvents();
          }
        }
      } catch (error) {
        console.error("Erreur lors du chargement des produits:", error);
        this.isLoading = false;
      }
    }
    /**
     * Met à jour l'état du bouton "more" en fonction de la page actuelle
     * @private
     */
    updateMoreButton() {
      if (!this.btnMore) return;
      if (this.currentPage >= this.maxPages) {
        this.btnMore.setAttribute("disabled", "disabled");
        this.btnMore.classList.add("button-disabled");
      } else {
        this.btnMore.removeAttribute("disabled");
        this.btnMore.classList.remove("button-disabled");
      }
    }
    disconnectedCallback() {
      if (this.btnMore) {
        this.btnMore.removeEventListener("click", this.loadMoreProducts);
      }
      window.removeEventListener("popstate", this.checkUrlOnLoad);
    }
  };
  customElements.define("t-collection", TCollection);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-cross-sell"] && !Shopify.designMode) return;
  try {
    
// ⚠ Auto-generated from src/sections/mini-cross-sell/mini-cross-sell.ts — do not edit directly.
// src/sections/mini-cross-sell/mini-cross-sell.ts
"use strict";
(() => {
  // src/sections/mini-cross-sell/mini-cross-sell.ts
  var MiniCrossSell = class extends HTMLElement {
    connectedCallback() {
    }
    disconnectedCallback() {
    }
  };
  if (!window.customElements.get("c-mini-cross-sell")) {
    window.customElements.define("c-mini-cross-sell", MiniCrossSell);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-add-to-cart"] && !Shopify.designMode) return;
  try {
    
// ⚠ Auto-generated from src/sections/popup-add-to-cart/popup-add-to-cart.ts — do not edit directly.
// src/sections/popup-add-to-cart/popup-add-to-cart.ts
"use strict";
(() => {
  // src/sections/popup-add-to-cart/popup-add-to-cart.ts
  var CPopupAtc = class extends HTMLElement {
    constructor() {
      super();
      this.timeout = null;
      this.dialog = this.querySelector("dialog");
    }
    connectedCallback() {
      document.addEventListener("cart:add-success", (e) => {
        if (e.detail?.action === "add") {
          this.open();
        }
      });
      this.addEventListener("click", (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;
        if (target.closest("[data-popup-atc-close]")) {
          this.close();
        }
      });
      this.dialog?.addEventListener("mouseover", (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;
        if (target.closest("[data-popup-atc-container]")) {
          clearTimeout(this.timeout ?? void 0);
        }
      });
      this.dialog?.addEventListener("mouseout", (event) => {
        const mouseEvent = event;
        const target = mouseEvent.target;
        if (!(target instanceof Element)) return;
        const container = target.closest("[data-popup-atc-container]");
        if (!container) return;
        const related = mouseEvent.relatedTarget;
        if (related instanceof Node && container.contains(related)) return;
        this.startCloseTimeout();
      });
    }
    open() {
      if (!this.dialog) return;
      document.documentElement.classList.add("is-overflow-hidden");
      this.updatePosition();
      if (typeof this.dialog.showModal === "function" && !this.dialog.open) {
        this.dialog.showModal();
      }
      setTimeout(() => {
        this.dialog?.classList.add("active");
      }, 10);
      this.startCloseTimeout();
    }
    close() {
      if (!this.dialog) return;
      this.dialog.classList.remove("active");
      if (typeof this.dialog.close === "function") {
        this.dialog.close();
      }
      document.documentElement.classList.remove("is-overflow-hidden");
      clearTimeout(this.timeout ?? void 0);
    }
    startCloseTimeout() {
      clearTimeout(this.timeout ?? void 0);
      this.timeout = setTimeout(() => this.close(), 3e3);
    }
    updatePosition() {
      const header = document.querySelector(".header") || document.querySelector("header");
      if (!header || !this.dialog) return;
      const rect = header.getBoundingClientRect();
      const headerBottom = rect.bottom;
      const raw = getComputedStyle(this.dialog).getPropertyValue("--header-block-size").trim();
      const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
      const headerBlockSize = raw.endsWith("rem") ? parseFloat(raw) * rootFontSize : parseFloat(raw) || 68;
      const offset = Math.max(0, headerBottom - headerBlockSize);
      this.dialog.style.setProperty("--header-overhead-offset", `${offset}px`);
    }
  };
  if (!customElements.get("c-popup-atc")) {
    customElements.define("c-popup-atc", CPopupAtc);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
// ⚠ Auto-generated from src/sections/product-information/product-information.ts — do not edit directly.
// src/sections/product-information/product-information.ts
"use strict";
(() => {
  // src/sections/product-information/product-information.ts
  var ProductInformation = class extends HTMLElement {
    constructor() {
      super(...arguments);
      this.activeSidebar = null;
      this.isAnimating = false;
      this.triggerButtons = [];
      this.closeButtons = [];
      this.onTriggerClick = (event) => {
        event.preventDefault();
        const target = event.currentTarget;
        const sidebarId = target?.dataset.informationSidebar;
        if (!sidebarId) return;
        this.openSidebar(sidebarId);
      };
      this.onCloseClick = (event) => {
        event.preventDefault();
        if (!this.activeSidebar) return;
        this.closeSidebar();
      };
      this.onDocumentKeydown = (event) => {
        if (event.key === "Escape" && this.activeSidebar) {
          this.closeSidebar();
        }
      };
    }
    connectedCallback() {
      this.triggerButtons = Array.from(
        this.querySelectorAll("[data-information-sidebar]")
      );
      this.closeButtons = Array.from(
        document.querySelectorAll("[data-information-sidebar-close]")
      );
      this.triggerButtons.forEach((button) => {
        button.addEventListener("click", this.onTriggerClick);
      });
      this.closeButtons.forEach((button) => {
        button.addEventListener("click", this.onCloseClick);
      });
    }
    disconnectedCallback() {
      this.triggerButtons.forEach((button) => {
        button.removeEventListener("click", this.onTriggerClick);
      });
      this.closeButtons.forEach((button) => {
        button.removeEventListener("click", this.onCloseClick);
      });
      document.removeEventListener("keydown", this.onDocumentKeydown);
      if (this.activeSidebar) {
        this.closeSidebar();
      }
    }
    openSidebar(sidebarId) {
      if (this.isAnimating) return;
      const sidebar = document.querySelector(
        `[data-information-sidebar-content="${sidebarId}"]`
      );
      if (!sidebar) return;
      this.isAnimating = true;
      this.activeSidebar = sidebarId;
      if (sidebar.parentNode !== document.body) {
        document.body.appendChild(sidebar);
      }
      document.body.classList.add("is-overflow-hidden");
      document.addEventListener("keydown", this.onDocumentKeydown);
      sidebar.classList.add("active");
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          sidebar.querySelector(".reinsurances-custom__sidebar-content")?.classList.add("active");
        });
      });
      window.setTimeout(() => {
        this.isAnimating = false;
      }, 400);
    }
    closeSidebar() {
      if (this.isAnimating || !this.activeSidebar) return;
      this.isAnimating = true;
      const sidebar = document.querySelector(
        `[data-information-sidebar-content="${this.activeSidebar}"]`
      );
      if (!sidebar) {
        this.isAnimating = false;
        return;
      }
      sidebar.querySelector(".reinsurances-custom__sidebar-content")?.classList.remove("active");
      document.body.classList.remove("is-overflow-hidden");
      document.removeEventListener("keydown", this.onDocumentKeydown);
      sidebar.classList.remove("active");
      this.activeSidebar = null;
      this.isAnimating = false;
    }
  };
  if (!window.customElements.get("c-product-information")) {
    window.customElements.define("c-product-information", ProductInformation);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-faq"] && !Shopify.designMode) return;
  try {
    
  //@ts-check
  class CFaq extends HTMLElement {
    constructor() {
      super()

      this.faqItems = this.querySelectorAll('.faq--item')
    }
    connectedCallback() {
      this.faqItems.forEach((item) => {
        const btn = item.querySelector('.faq--item--header')
        const content = item.querySelector('.faq--item--content')
        btn.setAttribute('aria-expanded', 'false')
        content.style.height = '0'
        btn.addEventListener('click', () => {
          const isOpen = btn.getAttribute('aria-expanded') === 'true'
          btn.setAttribute('aria-expanded', String(!isOpen))
          content.style.height = isOpen ? '0' : content.scrollHeight + 16 + 'px'
        })
      })
    }
  }
  if (!customElements.get('c-faq')) {
    customElements.define('c-faq', CFaq)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-in-page-nav"] && !Shopify.designMode) return;
  try {
    
// ⚠ Auto-generated from src/sections/section-in-page-nav/section-in-page-nav.ts — do not edit directly.
// src/sections/section-in-page-nav/section-in-page-nav.ts
"use strict";
(() => {
  // src/sections/section-in-page-nav/section-in-page-nav.ts
  var SectionInPageNav = class extends HTMLElement {
    constructor() {
      super(...arguments);
      /** @type {HTMLElement[]} */
      this.navItems = [];
      this.navSections = [];
      /** @type {Map<HTMLElement, string[]>} */
      this.navItemTargetIds = /* @__PURE__ */ new Map();
      /** @type {Map<string, HTMLElement>} */
      this.targetIdToNavItem = /* @__PURE__ */ new Map();
      /** @type {Map<string, HTMLElement>} */
      this.navSectionsByTargetId = /* @__PURE__ */ new Map();
      /** @type {HTMLElement[]} */
      this.tabPanels = [];
      this.navLayoutOption = "";
      this.boundHandleClick = this.handleClick.bind(this);
      this.boundHandleScroll = this.handleScroll.bind(this);
    }
    connectedCallback() {
      this.navLayoutOption = this.dataset.layoutOption ?? "";
      this.reOrderDom();
      this.navItems = Array.from(
        this.querySelectorAll(".section-in-page-nav__item")
      );
      this.cacheNavItemTargetIds();
      this.navItems.forEach((navItem) => {
        navItem.addEventListener("click", this.boundHandleClick);
      });
      if (this.navLayoutOption === "tabs") {
        this.initializeTabs();
        return;
      }
      if (this.navLayoutOption === "anchors") {
        window.addEventListener("scroll", this.boundHandleScroll);
      }
    }
    disconnectedCallback() {
      this.navItems.forEach((navItem) => {
        navItem.removeEventListener("click", this.boundHandleClick);
      });
      if (this.navLayoutOption === "anchors") {
        window.removeEventListener("scroll", this.boundHandleScroll);
      }
    }
    /**
     * Finds an element by exact data-internal-name value.
     * Avoids CSS selector escaping issues with apostrophes, slashes, etc.
     */
    findElementByInternalName(targetId) {
      const elements = document.querySelectorAll(
        "[data-internal-name]"
      );
      for (const element of elements) {
        if (!(element instanceof HTMLElement)) continue;
        if (element.getAttribute("data-internal-name") === targetId) {
          return element;
        }
      }
      return null;
    }
    reOrderDom() {
      this.navSections = [];
      this.navSectionsByTargetId = /* @__PURE__ */ new Map();
      const rawTargetIds = this.dataset.targetIds ?? "";
      const targetIds = this.parseTargetIds(rawTargetIds);
      targetIds.forEach((targetId) => {
        const targetSection = this.findElementByInternalName(targetId)?.parentElement;
        if (!targetSection) {
          return;
        }
        if (targetSection === this || this.contains(targetSection)) {
          return;
        }
        targetSection.setAttribute("data-internal-name", targetId);
        this.navSections.push(targetSection);
        this.navSectionsByTargetId.set(targetId, targetSection);
        this.appendChild(targetSection);
      });
    }
    /**
     * Parses a raw list of internal section ids.
     * Accepts ids separated by commas and/or any whitespace (including new lines).
     */
    parseTargetIds(raw) {
      const trimmed = raw.trim();
      if (!trimmed) return [];
      const normalized = trimmed.replace(/\r\n/g, "\n").replace(/\n+/g, ",");
      const tokens = normalized.split(",");
      const seen = /* @__PURE__ */ new Set();
      const result = [];
      tokens.forEach((token) => {
        const cleaned = token.replace(/^#/, "").trim();
        if (!cleaned) return;
        if (seen.has(cleaned)) return;
        seen.add(cleaned);
        result.push(cleaned);
      });
      return result;
    }
    /**
     * Cache nav item target id lists and build an inverse map (targetId -> owner navItem).
     */
    cacheNavItemTargetIds() {
      this.navItemTargetIds = /* @__PURE__ */ new Map();
      this.targetIdToNavItem = /* @__PURE__ */ new Map();
      this.navItems.forEach((navItem) => {
        const rawTargetIds = navItem.dataset.targetIds ?? "";
        const targetIds = this.parseTargetIds(rawTargetIds);
        this.navItemTargetIds.set(navItem, targetIds);
        targetIds.forEach((targetId) => {
          if (!this.targetIdToNavItem.has(targetId)) {
            this.targetIdToNavItem.set(targetId, navItem);
          }
        });
      });
    }
    getFirstExistingTargetId(targetIds) {
      for (const targetId of targetIds) {
        if (this.navSectionsByTargetId.has(targetId)) return targetId;
      }
      return "";
    }
    handleClick(event) {
      const eventTarget = event.target;
      if (!eventTarget) return;
      if (!(eventTarget instanceof Element)) return;
      const closestElement = eventTarget.closest(
        ".section-in-page-nav__item"
      );
      if (!closestElement || !(closestElement instanceof HTMLElement)) {
        return;
      }
      const targetNavItem = closestElement;
      const targetIds = this.navItemTargetIds.get(targetNavItem) ?? [];
      if (this.navLayoutOption === "tabs") {
        this.activateNavItem(targetNavItem);
      }
      const targetId = this.getFirstExistingTargetId(targetIds);
      if (!targetId) return;
      this.findElementByInternalName(targetId)?.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
    initializeTabs() {
      this.tabPanels = [];
      let firstValidNavItem = null;
      this.navItems.forEach((navItem, index) => {
        const panelId = `section-in-page-nav-panel-${this.sectionId}-${index}`;
        const panelEl = document.createElement("div");
        panelEl.id = panelId;
        panelEl.setAttribute("role", "tabpanel");
        panelEl.setAttribute("aria-labelledby", navItem.id);
        panelEl.hidden = true;
        panelEl.style.display = "none";
        navItem.setAttribute("aria-controls", panelId);
        navItem.setAttribute("aria-selected", "false");
        const targetIds = this.navItemTargetIds.get(navItem) ?? [];
        let hasAnyTargetSection = false;
        targetIds.forEach((targetId) => {
          if (this.targetIdToNavItem.get(targetId) !== navItem) return;
          const targetSection = this.navSectionsByTargetId.get(targetId);
          if (!targetSection) return;
          panelEl.appendChild(targetSection);
          hasAnyTargetSection = true;
        });
        this.tabPanels.push(panelEl);
        this.appendChild(panelEl);
        if (!firstValidNavItem && hasAnyTargetSection) {
          firstValidNavItem = navItem;
        }
      });
      if (firstValidNavItem) {
        this.activateNavItem(firstValidNavItem);
      }
    }
    activateNavItem(activeNavItem) {
      this.navItems.forEach((navItem) => {
        navItem.classList.toggle("is-active", navItem === activeNavItem);
        navItem.setAttribute(
          "aria-selected",
          navItem === activeNavItem ? "true" : "false"
        );
      });
      this.tabPanels.forEach((panelEl, index) => {
        panelEl.hidden = !(this.navItems[index] === activeNavItem);
        panelEl.style.display = this.navItems[index] === activeNavItem ? "block" : "none";
      });
    }
    get sectionId() {
      return this.id || this.dataset.sectionId || "section";
    }
    handleScroll() {
      let activeTargetId = "";
      this.navSections.forEach((navSection) => {
        if (this.isCurrentSection(navSection)) {
          activeTargetId = navSection.dataset.internalName ?? "";
        }
      });
      this.navItems.forEach((navItem) => {
        const targetIds = this.navItemTargetIds.get(navItem) ?? [];
        if (targetIds.includes(activeTargetId)) {
          navItem.classList.add("is-active");
        } else {
          navItem.classList.remove("is-active");
          if (document.activeElement === navItem) {
            navItem.blur();
          }
        }
      });
    }
    isCurrentSection(navSection) {
      return navSection.getBoundingClientRect().top < 200;
    }
  };
  if (!window.customElements.get("c-section-in-page-nav")) {
    window.customElements.define("c-section-in-page-nav", SectionInPageNav);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-text-gallery-media"] && !Shopify.designMode) return;
  try {
    
// ⚠ Auto-generated from src/sections/section-text-gallery-media/section-text-gallery-media.ts — do not edit directly.
// src/sections/section-text-gallery-media/section-text-gallery-media.ts
"use strict";
(() => {
  // src/sections/section-text-gallery-media/section-text-gallery-media.ts
  var SectionTextGalleryMedia = class extends HTMLElement {
    connectedCallback() {
    }
    disconnectedCallback() {
    }
  };
  if (!window.customElements.get("c-section-text-gallery-media")) {
    window.customElements.define(
      "c-section-text-gallery-media",
      SectionTextGalleryMedia
    );
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["set-to-compose-product"]) return;
  try {
    
// ⚠ Auto-generated from src/sections/set-to-compose-product/set-to-compose-product.ts — do not edit directly.
// src/sections/set-to-compose-product/set-to-compose-product.ts
"use strict";
(() => {
  // src/sections/set-to-compose-product/set-to-compose-product.ts
  var SetToComposeProduct = class extends HTMLElement {
    constructor() {
      super(...arguments);
      this.errorMessage = null;
      this.errorMessageButton = null;
      this.handleErrorMessageClose = () => {
        if (this.errorMessage && !this.errorMessage.classList.contains("hidden")) {
          this.errorMessage.classList.add("hidden");
        }
      };
    }
    connectedCallback() {
      this.errorMessage = this.querySelector(
        "[data-set-to-compose-error-message]"
      );
      this.errorMessageButton = this.errorMessage?.querySelector(
        ".set-to-compose-product_error-message_button"
      ) ?? null;
      this.errorMessageButton?.addEventListener(
        "click",
        this.handleErrorMessageClose
      );
    }
    disconnectedCallback() {
      this.errorMessageButton?.removeEventListener(
        "click",
        this.handleErrorMessageClose
      );
    }
  };
  if (!window.customElements.get("c-set-to-compose-product")) {
    window.customElements.define("c-set-to-compose-product", SetToComposeProduct);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable"] && !Shopify.designMode) return;
  try {
    
// ⚠ Auto-generated from src/sections/shoppable/shoppable.ts — do not edit directly.
// src/sections/shoppable/shoppable.ts
"use strict";
(() => {
  // src/sections/shoppable/shoppable.ts
  if (!window.shoppableInitialized) {
    window.shoppableInitialized = true;
    document.addEventListener("DOMContentLoaded", function() {
      const pins = document.querySelectorAll("[data-shoppable-pin]");
      const contents = document.querySelectorAll("[data-shoppable-content]");
      pins.forEach((pin) => {
        pin.addEventListener("click", function(e) {
          e.stopPropagation();
          const blockId = pin.getAttribute("data-block-id");
          const contentToOpen = document.querySelector(
            '[data-shoppable-content][data-block-id="' + blockId + '"]'
          );
          if (contentToOpen && contentToOpen.classList.contains("active")) {
            contentToOpen.classList.remove("active");
            return;
          }
          contents.forEach((content) => {
            content.classList.remove("active");
          });
          if (contentToOpen) {
            const parent = pin.closest(".text-image__content-image");
            if (parent) {
              const parentRect = parent.getBoundingClientRect();
              const pinRect = pin.getBoundingClientRect();
              const contentWidth = 325;
              const contentHeight = 140;
              contentToOpen.style.position = "absolute";
              if (window.innerWidth <= 1024) {
                contentToOpen.style.top = "50%";
                contentToOpen.style.left = "50%";
                contentToOpen.style.transform = "translate(-50%, -50%)";
              } else {
                contentToOpen.style.transform = "none";
                const borderThreshold = 16;
                const pinLeftRelative = pinRect.left - parentRect.left;
                const pinTopRelative = pinRect.top - parentRect.top;
                const pinXPercent = pinLeftRelative / parentRect.width;
                const pinYPercent = pinTopRelative / parentRect.height;
                const isTop = pinYPercent < 0.5;
                const isLeft = pinXPercent < 0.5;
                let cardTop, cardLeft;
                if (isTop && isLeft) {
                  cardTop = pinTopRelative;
                  cardLeft = pinLeftRelative + pinRect.width + 8;
                } else if (isTop && !isLeft) {
                  cardTop = pinTopRelative;
                  cardLeft = pinLeftRelative - contentWidth - 44;
                } else if (!isTop && isLeft) {
                  cardTop = pinTopRelative + pinRect.height - contentHeight;
                  cardLeft = pinLeftRelative + pinRect.width + 8;
                } else {
                  cardTop = pinTopRelative + pinRect.height - contentHeight;
                  cardLeft = pinLeftRelative - contentWidth - 44;
                }
                if (cardTop < borderThreshold) {
                  cardTop = borderThreshold;
                } else if (cardTop + contentHeight > parentRect.height - borderThreshold) {
                  cardTop = parentRect.height - contentHeight - borderThreshold;
                }
                if (cardLeft < borderThreshold) {
                  cardLeft = borderThreshold;
                } else if (cardLeft + contentWidth > parentRect.width - borderThreshold) {
                  cardLeft = parentRect.width - contentWidth - borderThreshold;
                }
                contentToOpen.style.top = cardTop + "px";
                contentToOpen.style.left = cardLeft + "px";
              }
            }
            contentToOpen.classList.add("active");
          }
        });
      });
      contents.forEach((content) => {
        content.addEventListener("click", function(e) {
          e.stopPropagation();
        });
      });
      document.addEventListener("click", function() {
        contents.forEach((content) => {
          content.classList.remove("active");
        });
      });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spotify"] && !Shopify.designMode) return;
  try {
    
// ⚠ Auto-generated from src/sections/spotify/spotify.ts — do not edit directly.
// src/sections/spotify/spotify.ts
"use strict";
(() => {
  // src/sections/spotify/spotify.ts
  var Spotify = class extends HTMLElement {
    connectedCallback() {
      const height = this.getAttribute("data-height");
      const iframe = this.querySelector("iframe");
      if (iframe) {
        iframe.style.height = `${height}px`;
      }
    }
    disconnectedCallback() {
    }
  };
  if (!window.customElements.get("c-spotify")) {
    window.customElements.define("c-spotify", Spotify);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
